<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
    ref="table"
  >
    <template #header>
      <Tabs type="card" v-model="tabName" @on-click="handleTab">
        <TabPane
          :label="item.name"
          :name="item.type"
          v-for="item in tabList"
          :key="item.type"
        />
      </Tabs>
    </template>
    <template #cost="{ visible, params, close }">
      <CostPage :rows="params" :close="close" v-if="visible"/>
    </template>
    <template #DETAILS="{ visible, params }">
      <Double :awbno="params.row.airway_number" v-if="visible"/>
      <audio ref="audio" preload style="display: none">
        <source :src="audiosrc"/>
      </audio>
    </template>
    <template #STATUS="{ visible, params }">
      <Tracker :statusId="params.row.airway_number" v-if="visible"/>
    </template>
    <template #ADJUST="{ visible, params }">
      <Adjust :awbno="params.airway_number" v-if="visible"/>
    </template>
    <template #UNPACK="{ visible, params }">
      <Unpack
        :itemId="params.row.id"
        :statusId="params.row.airway_number"
        v-if="visible"
      />
    </template>

    <template #INFO="{ visible, params, close }">
      <DoubleInfo :row="params.row" :close="close" v-if="visible"/>
    </template>
    <template #FREIGHT="{ visible, params, close }">
      <DoubleBill
        ref="FREIGHT"
        :row="params.row"
        :close="close"
        v-if="visible"
      />
    </template>
    <template #INBOUND="{ visible, params }">
      <B2bInbound
        ref="inbound"
        :billId="params.row.airway_number"
        v-if="visible"
      />
    </template>
    <template #OUT="{ visible, params }">
      <Outbound :billId="params.row.airway_number" v-if="visible"/>
    </template>
    <template #PACK="{ visible, params }">
      <Pack :billId="params.row.airway_number" v-if="visible"/>
    </template>
    <template #UPLOAD="{ params, visible, close }">
      <UploadFile
        :url="params.url"
        :uploadFunction="params.requestApi"
        :close="close"
        :resTable="params.resTable"
        v-if="visible"
      />
    </template>
    <template #datails="{ visible, params }">
      <Details :billId="params.row.airway_number" v-if="visible"/>
    </template>
    <template #branchFright="{ visible, params, close }">
      <BranchFeright
        :row="params"
        v-if="visible"
        ref="branchFeright"
        :close="close"
      />
    </template>
  </cTable>
</template>

<script>
import {getAllClient, getAllPackageSize} from "@/api/user/client";
import CostPage from "./cost.vue";
import {getConfig, getSubjectCost} from "@/api/tracker/cost_page";
import Adjust from "./adjust.vue";
import {
  getDoubleList,
  printDouble,
  getB2bConfig,
  changeSheet,
  del,
  getOrderCount,
  uploadFiles,
  uploadInfoFiles,
  uploadInboundFile,
  getAuditList,
  checkWeight,
  getPackList,
  readPackBox,
  postPacking,
  bachPack,
  getB2bType,
  downloadBox,
  getContacts,
  getWhService,
  saveService,
  getServiceDetail,
  exportFinance,
  batchUpdateTrack,
  getService,
  getUser as gerUrl1,
  batchService,
  batchSetAgentNumber,
  uploadB2BFiles,
  batchSetRemarks,
  costShare,
  log,
  uploadRemarks,
  editTransport,
  doubleFeright,
  errorOrder,
  delError,
  fordel,
  exportDeliverty,
  abnormalInfo,
  abnormalSave,
  batchdel, modifyShipments, exportSelection
} from "@/api/double/list";
import {getUser, getWaitSettlementSalesman} from "@/api/user/internal";
import {getCountry, getCountryCity} from "@/api/system/country";
import {getCompanies} from "@/api/user/client";
import {getMethod} from "@/api/system/method";
import {getCity} from "@/api/system/city";
import {getAgent} from "@/api/tracker/agent";

import copyClick from "@/utils/copyClick";
import jsonp from "jsonp";

import cTable from "@/base/common/index";
import Double from "_my/double-details";
import DoubleInfo from "_my/double-info";
import DoubleBill from "_my/double-bill";
import Tracker from "@/base/order_tracker";
import Unpack from "_my/unpack";
import B2bInbound from "_my/b2b-inbound";
import Outbound from "./out";
import Pack from "./pack";
import UploadFile from "@/base/upload_file";
import Details from "./details";
import BranchFeright from "./feright";
import {getStatus} from "@/api/tracker/status";
import {getSelectType, getKeysType} from "@/api/public";
import {getGoodsInfo, saveGoodsInfo, addRemark} from "@/api/double/list";
import {getCurrency} from "@/api/finance/currency";
import {getCountryCategory} from "@/api/storage/category";
import getLodop from "@/utils/lodop";
import {searchCustomer} from "@/api/tracker/sea";
import {markAsPaid} from "@/api/double/bill";
import {removeFeesItem, upgradeFeesItem} from "@/api/double/adjust";

export default {
  components: {
    CostPage,
    cTable,
    Double,
    Tracker,
    DoubleInfo,
    DoubleBill,
    Unpack,
    B2bInbound,
    Outbound,
    Pack,
    UploadFile,
    Details,
    BranchFeright,
    Adjust
  },
  methods: {
    uploadFormData(data) {
      let formData = new FormData();
      for (let i = 0; i < data.length; i++) {
        formData.append("files[]", data[i]);
      }
      uploadFiles(formData).then(res => {
        this.$Message[res.data.status ? "success" : "error"]({
          background: true,
          content: res.data.msg
        });
        if (res.data.status) {
          this.filesList = [];
          this.$refs["table"].getList();
        }
      });
    },
    playaudio(src) {
      let that = this;
      this.audiosrc = `${src}`;
      setTimeout(() => {
        that.$refs.audio.pause();
        that.$refs.audio.load();
        that.$refs.audio.play();
      }, 500);
    },
    handleTab() {
      this.$refs["table"].resize();
      this.$refs["table"].getList(1);
      this.$refs["table"].getTable().recalculate(true);
    },
    print(row) {
      let lodop = getLodop(this);
      if (!lodop) {
        return false;
      }
      lodop.PRINT_INIT(this.company + this.$t("ClaimsLetter")); //首先一个初始化语句
      lodop.SET_PRINT_PAGESIZE(1, 0, 0, "A4"); //规定纸张大小；使用A4纸

      // 绘制二维码
      lodop.ADD_PRINT_BARCODE(15, 20, 220, 60, '128B', row.airway_number)
      lodop.ADD_PRINT_BARCODE(580, 15, 220, 60, '128B', row.airway_number)

      lodop.ADD_PRINT_LINE("50%", "0", "50%", "100%", 0, 1);
      Array(2)
        .fill(1)
        .forEach((_, i) => {
          let top = i * 50;
          lodop.SET_PRINT_STYLE("FontSize", 20);
          lodop.SET_PRINT_STYLE("Alignment", 2);
          lodop.SET_PRINT_STYLE("Bold", 1);
          lodop.ADD_PRINT_TEXT(
            top + 2 + "%",
            "0%",
            "100%",
            "30px",
            "PROOF OF DELIVERY"
          );
          lodop.SET_PRINT_STYLE("Alignment", 1);
          lodop.SET_PRINT_STYLE("Bold", 0);
          lodop.SET_PRINT_STYLE("FontSize", 12);
          lodop.ADD_PRINT_TABLE(
            top + 10 + "%",
            "5%",
            "90%",
            "30%",
            `<table border="1"  style="width:50%;border-width: 1px;border-collapse: collapse;">
            <tr >
                <td style="height:30px;padding:3px">Consignee Detsils:</td>
            </tr>
            <tr >
                <td style="height:200px;vertical-align: top;padding:3px">
<div>${row.consignee_contact}</div>
<div>${row.consignee_cellular}</div>
<div>&nbsp</div>
${row.consignee_address}
                </td>
            </tr>
        </table>`
          );
          lodop.ADD_PRINT_TEXT(
            top + 4 + "%",
            "55%",
            "40%",
            "30%",
            `
    DOC. NO.:
                        DATE:
Notice:
1.We confirm receipt of the above specified shipment / Goods /Cargo in good order and condition.
2.If you have any objection, please raise it within 3 days after receiving the goods"

Shipper ’s Signature：

Receiver ’s Signature：
`
          );
          lodop.ADD_PRINT_TABLE(
            top + 36 + "%",
            "5%",
            "90%",
            200,
            `<table border="1" style="width:100%;border-width: 1px;border-collapse: collapse;">
              <tr style="height:40px;text-align:center">
                  <td>TRACKING NUMBER</td>
                  <td>DESCRIPTION</td>
                  <td>TOTAL PKG</td>
                  <td>&nbsp&nbsp&nbsp&nbsp</td>
                  <td>G.W</td>
                  <td>VOL</td>
                  <td>COD  AMOUND</td>
              </tr>
              <tr style="height:30px;text-align:center">
                  <td>${row.airway_number}</td>
                  <td></td>
                  <td>${row.quantity}</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td>${
              parseFloat(row.cod_amount)
                ? row.cod_amount + " " + row.cod_currency
                : ""
            }</td>
              </tr>
          </table>`
          );
        });
      lodop.PREVIEW(); //打印预览
    }
  },
  async mounted() {
    let client = (await getAllClient()).data.payload.rows;
    let service = (await gerUrl1({type: 1})).data.payload;
    service = [].concat(...service[1], ...service[2], ...service[3]);
    let salesman = (await getUser({standard: "Salesman"})).data.payload.rows;
    let country = (await getCountry({allow_arrive: 1})).data.payload.rows;
    let status = (await getB2bConfig()).data.payload.status;
    let types = (await getB2bType()).data.payload;
    let dingcang_company = (await getContacts()).data.payload;
    let baoguan_agent = (await getAgent()).data.payload.rows;
    let config = (await getConfig()).data.payload;
    let currencyList = (await getCurrency()).data.payload.rows;
    let cateList = (await getCountryCategory({country: "SA"})).data.payload;
    let packageSize = (await getAllPackageSize()).data.payload
    this.dingcang_company = dingcang_company["ding"];
    const data = (
      await getSelectType([
        "OMS_B2B_IS_OUTBOUND",
        "OMS_B2B_IS_INTBOUND",
        "OMS_B2B_ORDER_STATUS"
      ])
    ).data.payload;
    this.header.searchs.forEach(item => {
      //if (item.key === "client_id") item.options = client;
      if (item.key === "dbl_service") item.options = service;
      if (item.key === "seller") item.options = salesman;
      if (item.key === "countryCode") item.options = country;
      if (item.key === "status") item.options = status;
      if (item.key === "packageSize") item.options = packageSize;
      if (item.key === "in_warehouse")
        item.options = data["OMS_B2B_IS_INTBOUND"];
      if (item.key === "out_warehouse")
        item.options = data["OMS_B2B_IS_OUTBOUND"];
      if (item.key === "track_status")
        item.options = data["OMS_B2B_ORDER_STATUS"];
      if (item.key === "dingcang_company")
        item.options = dingcang_company["ding"];
      if (item.key === "dbl_status") {
        item.options = Object.keys(status).map(item => ({
          value: item,
          label: status[item]
        }));
      }
    });
    this.modals.updateTrace.fields.forEach(async it => {
      if (it.key == "country_id") {
        it.options = (await getCountry()).data.payload.rows;
      }
      if (it.key === "trace_code") {
        let optList = types["track_code"].map(item => {
          if (typeof item.value == "number") {
            item.value = item.value.toString();
          }
          return item;
        });
        it.options = optList;
      }
      // if (it.key === "track_status") {
      //   it.options = data["OMS_B2B_ORDER_STATUS"];
      // }
    });
    this.modals.doubleFeright.table.fields.forEach(el => {
      if (el.key == "dingcang_company") el.options = dingcang_company["ding"];
      if (~["is_safe", "is_solely"].indexOf(el.key))
        el.options = [
          {value: el.key == "is_solely" ? "YES" : 1, label: this.$t("YES")},
          {value: el.key == "is_solely" ? "NO" : 2, label: this.$t("NO")}
        ];
    });
    this.modals.doubleFeright.fields.forEach(el => {
      if (el.key == "cate_id") el.options = cateList;
    });
    this.modals.B2BCostApportion.fields.forEach(async el => {
      if (el.key == "currency") el.options = currencyList;
      if (el.key == "agent_id") el.options = baoguan_agent;
    });
  },
  data() {
    let deliverList = [
      {
        label: this.$t("PickAtDoor"),
        value: 1
      },
      {
        label: this.$t("SelfDelivery"),
        value: 2
      },
      {
        label: this.$t("ExpressLogistics"),
        value: 3
      }
    ];
    return {
      tabName: "AllOrder",
      filesList: [],
      audiosrc: "",
      tabList: [],
      dingcang_company: [],
      currentEditElementId: 0,
      methods: {
        list: p => {
          // if (this.tabList.length == 0) {
          this.methods.getOrderCount();
          // }
          p.select_type = this.tabName;
          return getDoubleList(p);
        },
        batchService,
        getAllClient,
        getUser,
        getCountry,
        getCity,
        getStatus,
        getB2bConfig,
        del,
        getOrderCount: async () => {
          let res = await getOrderCount();
          this.tabList = res.data.payload;
        },
        uploadFiles,
        uploadInfoFiles,
        readPackBox,
        postPacking,
        getPackList,
        bachPack,
        getAuditList,
        checkWeight,
        getB2bType,
        downloadBox,
        getMethod,
        getGoodsInfo,
        saveGoodsInfo,
        addRemark,
        getContacts,
        getWhService,
        saveService,
        getServiceDetail,
        exportFinance,
        batchUpdateTrack,
        batchSetAgentNumber,
        batchSetRemarks,
        costShare,
        log,
        uploadRemarks,
        editTransport,
        doubleFeright,
        errorOrder,
        delError,
        fordel,
        exportDeliverty,
        abnormalSave,
        abnormalInfo,
        batchdel,
        modifyShipments,
        getAllPackageSize
      },
      config: {
        height: 630
      },
      modals: {
        batchDel: {
          type: "add",
          methods: {
            ok({row, close}) {
              let data = this.handleFilterData();
              this.$page
                .handleRequestMethods("batchdel", data, true, true)
                .then(res => {
                  this.$page.getList();
                  close();
                });
            }
          },
          config: {
            title: this.$tz("批量,删除,分包"),
            modalBind: {
              width: 500
            },
            formBind: {
              labelWidth: 100
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              airway_number: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur"
                }
              ]
            }
          },
          grid: [{airway_number: 24}],
          fields: [
            {
              key: "airway_number",
              name: () => this.$tz("订单号码"),
              placeholder() {
                return this.$tz("订单号码");
              },
              component: "Input",
              bind: {
                type: "textarea",
                autosize: {minRows: 5}
              }
            }
          ]
        },
        adjust: {
          contentSlot: "ADJUST",
          config: {
            modalBind: {
              width: 1060,
              draggable: true,
              sticky: true
            }
          },
          footer: {
            show: () => false
          }
        },
        abnormal: {
          type: "add",
          methods: {
            ok({row, close}) {
              let data = this.handleFilterData({
                airway_number: row.airway_number
              });
              this.$page
                .handleRequestMethods("abnormalSave", data, true, true)
                .then(res => {
                  this.$page.getList();
                  close();
                });
            }
          },
          config: {
            title: this.$tz("异常"),
            modalBind: {
              width: 600
            },
            formBind: {
              labelWidth: 100
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              cause_type: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                  type: "number"
                }
              ],
              new_number: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur"
                }
              ],
              remarks: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur"
                }
              ]
            }
          },
          grid: [{cause_type: 24}, {new_number: 24}, {remarks: 24}],
          fields: [
            {
              name: this.$tz("异常,原因"),
              key: "cause_type",
              component: "Select",
              placeholder: () => this.$tz("异常,原因"),
              options: [],
              optionsFn: "causeType",
              optionsKey: "",
              default: ""
            },
            {
              name: () => this.$tz("订单号码"),
              key: "new_number",
              component: "Input",
              placeholder: () => this.$tz("订单号码"),
              show: ({row}) => row.cause_type == 2
            },
            {
              key: "remarks",
              name: () => this.$tz("备注"),
              placeholder() {
                return this.$tz("备注");
              },
              component: "Input",
              bind: {
                type: "textarea",
                autosize: {minRows: 3}
              },
              show: ({row}) => row.cause_type == 99
            }
          ]
        },
        quantity: {
          config: {
            title: this.$tz(""),
            modalBind: {
              width: 1000
            }
          },
          footer: {
            show: () => false
          },
          header: {
            show: () => true,
            btns: [
              {
                name: () => this.$tz("导出"),
                type: "export",
                fnName: "export",
                bind: {
                  type: "primary"
                }
              }
            ],
            methods: {
              export() {
                this.$page.exportExc({
                  fields: this.table.fields,
                  data: this.list
                });
              }
            }
          },
          table: {
            config: {
              height: 600
            },
            fields: [
              {
                name() {
                  return this.$tz("订单号码") + `(${this.$modal.list.length})`;
                },
                key: "airway_number",
                minWidth: 110,
                header: {
                  copy: true
                },
                copy: true
              },
              {
                name: () => this.$tz("申明重量"),
                key: "claim_weight",
                minWidth: 110
              },
              {
                name: () => this.$tz("入库重量"),
                key: "check_weight",
                minWidth: 110
              },
              {
                name: () => this.$tz("申报价值"),
                key: "values",
                minWidth: 110
              }
            ]
          }
        },
        errorOrder: {
          type: "add",
          methods: {
            ok({row, close}) {
              let data = this.handleFilterData({id: row.id});
              this.$page
                .handleRequestMethods(
                  data.id ? "update" : "add",
                  data,
                  true,
                  true
                )
                .then(res => {
                  this.$page.getList();
                  close();
                });
            }
          },
          config: {
            title: this.$tz("错误,订单"),
            listFn: "errorOrder",
            modalBind: {
              width: 500
            }
          },
          table: {
            header: {
              btns: {
                list: [
                  {
                    name: () => this.$tz("删除"),
                    type: "del",
                    fnName: "del",
                    bind: {
                      type: "error"
                    }
                  }
                ],
                methods: {
                  del() {
                    let modal = this.getModal("errorOrder");
                    this.$Modal.confirm({
                      title: this.$tz("删除"),
                      width: 300,
                      content: this.$t("titleModal"),
                      onOk: () => {
                        this.handleRequestMethods(
                          "delError",
                          {id: modal.selectAll.map(t => t.id)},
                          true,
                          true
                        ).then(res => {
                          modal.getList();
                        });
                      }
                    });
                  }
                }
              }
            },
            config: {
              height: 500
            },
            fields: [
              {
                type: "checkbox",
                width: 50,
                align: "center"
              },
              {
                name: () => this.$tz("错误信息"),
                key: "return_data",
                minWidth: 110
              },
              {
                name: () => this.$tz("添加时间"),
                key: "create_time",
                minWidth: 110
              }
            ]
          }
        },
        doubleFeright: {
          methods: {
            ok({row, close}) {
              row.extend = this.list;
              this.$page.handleRequestMethods("doubleFeright", row).then(e => {
                this.$page.getList();
                close();
              });
            }
          },
          footer: {
            ok: {},
            cancel: {}
          },
          config: {
            passedVars: {},
            modalBind: {
              width: 1000
            },
            formBind: {
              labelWidth: 100
            },
            rowBind: {
              gutter: 13,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              cate_id: [
                {
                  required: true,
                  message: "cannot be empty",
                  type: "number",
                  trigger: "change"
                }
              ],
              charged: [
                {
                  required: true,
                  message: "cannot be empty",
                  type: "number",
                  trigger: "change"
                }
              ],
              dingcang_company: [
                {
                  required: true,
                  message: "cannot be empty",
                  type: "number",
                  trigger: "change"
                }
              ]
            }
          },
          grid: [
            {cate_id: 8, charged: 8, is_confirm: 8},
            {dingcang_company: 8}
          ],
          fields: [
            {
              key: "cate_id",
              name: () => this.$t("category"),
              component: "Select",
              config: {
                label: "name",
                value: "id"
              },
              options: [],
              methods: {
                list: ({field}) => {
                  let vars = this.$store.state.app.cateVars
                  getCountryCategory({country: vars.toCountry, transport: vars.transportMode}).then(r => {
                    field.options = r.data.payload
                    this.$forceUpdate()
                  })
                }
              },
              placeholder() {
                return this.$t("select") + this.$t("category");
              }
            },
            {
              key: "charged",
              name: () => this.$t("battery"),
              component: "Select",
              options: [
                {value: 1, label: this.$t("YES")},
                {value: 2, label: this.$t("NO")}
              ],
              placeholder() {
                return this.$t("select") + this.$t("battery");
              }
            },
            {
              key: "is_confirm",
              name: () => this.$t("whether") + this.$t("doubleFeright"),
              component: "Select",
              options: [
                {value: 1, label: this.$t("YES")},
                {value: 2, label: this.$t("NO")}
              ],
              placeholder() {
                return (
                  this.$t("select") +
                  this.$t("whether") +
                  this.$t("doubleFeright")
                );
              }
            },
            {
              name: () => this.$t("dingcangCompany"),
              key: "dingcang_company",
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("dingcangCompany");
              },
              config: {
                label({row}) {
                  return row.code + "(" + row.alias + ")";
                },
                value: "id"
              },
              minWidth: 120,
              options: [],
              methods: {
                list: ({field}) => {
                  !field.options.length &&
                  (field.options = this.dingcang_company);
                }
              }
            }
          ],
          table: {
            config: {
              height: 500
            },
            fields: [
              {
                name: () => this.$t("orderNum"),
                key: "airway_number",
                placeholder() {
                  return this.$t("orderNum");
                },
                minWidth: 120
              },
              {
                key: "is_safe",
                name: () => this.$t("safetyService"),
                component: "Select",
                options: [],
                placeholder() {
                  return this.$t("select") + this.$t("safetyService");
                },
                minWidth: 120,
                methods: {
                  list: ({field}) => {
                    !field.options.length &&
                    (field.options = [
                      {value: 1, label: this.$t("YES")},
                      {value: 2, label: this.$t("NO")}
                    ]);
                  }
                }
              },
              {
                key: "is_solely",
                name: () => this.$t("is_solely"),
                component: "Select",
                options: [],
                placeholder() {
                  return this.$t("select") + this.$t("is_solely");
                },
                methods: {
                  list: ({field}) => {
                    !field.options.length &&
                    (field.options = [
                      {value: "YES", label: this.$t("YES")},
                      {value: "NO", label: this.$t("NO")}
                    ]);
                  }
                },
                minWidth: 120
              },
              {
                name: () => this.$t("Document Set"),
                key: "documents",
                component: "Input",
                placeholder() {
                  return this.$t("Document Set");
                },
                minWidth: 120
              },
              {
                name: () => this.$t("next_page"),
                key: "xu_page",
                component: "Input",
                placeholder() {
                  return this.$t("next_page");
                },
                minWidth: 120
              },
              {
                name: () => this.$t("DeclaredValue"),
                key: "values",
                component: "Input",
                placeholder() {
                  return this.$t("DeclaredValue");
                },
                minWidth: 120
              },
              {
                name: () => this.$t("Remarks"),
                key: "remarks",
                component: "Input",
                placeholder() {
                  return this.$t("Remarks");
                },
                minWidth: 120
              }
            ]
          }
        },
        B2BCostApportion: {
          methods: {
            ok({row, close}) {
              this.$page.handleRequestMethods("costShare", row).then(e => {
                this.$page.getList();
                close();
              });
            }
          },
          footer: {
            ok: {},
            cancel: {}
          },
          config: {
            modalBind: {
              width: 600
            },
            formBind: {
              labelWidth: 100
            },
            rowBind: {
              gutter: 13,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              airway_number: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "change"
                }
              ],
              expense_item: [
                {
                  required: true,
                  message: "cannot be empty",
                  type: "array",
                  trigger: "change"
                }
              ],
              currency: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "change"
                }
              ],
              charging_value: [
                {
                  required: true,
                  message: "cannot be empty",
                  type: "number",
                  trigger: "change"
                }
              ],
              price: [
                {
                  required: true,
                  message: "cannot be empty",
                  type: "number",
                  trigger: "change"
                }
              ],
              agent_id: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "change",
                  type: "number"
                }
              ]
            }
          },
          grid: [
            {airway_number: 24},
            {expense_item: 24},
            {agent_id: 24},
            {currency: 24},
            {charging_value: 24},
            {price: 24},
            {amount: 24},
            {remarks: 24}
          ],
          fields: [
            {
              key: "airway_number",
              name: () => this.$t("order_number"),
              component: "Input",
              bind: {
                type: "textarea"
              },
              placeholder() {
                return this.$t("enter") + this.$t("order_number");
              }
            },
            {
              name: () => this.$t("expense"),
              key: "expense_item",
              minWidth: 120,
              component: "Cascader",
              placeholder() {
                return this.$t("select") + this.$t("expense");
              },
              options: [],
              default: [],
              methods: {
                async list({field}) {
                  field.options = (
                    await getSubjectCost({pid: 0})
                  ).data.payload;
                },
                async loadData({item, callback}) {
                  item.loading = true;
                  item.children = (
                    await getSubjectCost({pid: item.value})
                  ).data.payload;
                  item.loading = false;
                  callback();
                }
              }
            },
            {
              name: () => this.$t("agentName"),
              key: "agent_id",
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("agentName");
              },
              options: [],
              config: {
                label: "agent_name",
                value: "id"
              },
              disabled({row}) {
                return row.bill_id > 0;
              },
              methods: {
                render({field, value}) {
                  return (
                    (field.options.find(t => t.value === value) || {}).label ||
                    "-"
                  );
                }
              }
            },
            {
              name: () => this.$t("calculation") + this.$t("currency_t"),
              key: "currency",
              placeholder() {
                return (
                  this.$t("select") +
                  this.$t("calculation") +
                  this.$t("currency_t")
                );
              },
              config: {
                label: "title",
                value: "code"
              },
              options: [],
              component: "Select"
            },
            {
              key: "charging_value",
              name: () => this.$t("quantity1"),
              bind: {
                style: {
                  width: "100%"
                }
              },
              component: "InputNumber",
              placeholder() {
                return this.$t("enter") + this.$t("quantity1");
              },
              methods: {
                "on-change"({formData}) {
                  formData["amount"] =
                    formData["charging_value"] * formData["price"];
                }
              }
            },
            {
              key: "price",
              name: () => this.$t("billing_price"),
              bind: {
                style: {
                  width: "100%"
                }
              },
              component: "InputNumber",
              placeholder() {
                return this.$t("enter") + this.$t("billing_price");
              },
              methods: {
                "on-change"({row}) {
                  row["amount"] = row["charging_value"] * row["price"];
                }
              }
            },
            {
              key: "amount",
              name: () => this.$t("cost_fee"),
              bind: {
                style: {
                  width: "100%"
                }
              },
              component: "Input",
              disabled: true,
              placeholder() {
                return this.$t("enter") + this.$t("cost_fee");
              }
            },
            {
              key: "remarks",
              name: () => this.$t("Remarks"),
              component: "Input",
              bind: {
                type: "textarea"
              },
              placeholder() {
                return this.$t("enter") + this.$t("Remarks");
              }
            }
          ]
        },
        batchSetRemarks: {
          type: "add",
          methods: {
            ok: async ({row, close}) => {
              let page = this.$refs["table"];
              if (row.src1) {
                page.openLoading();
                let form = new FormData();
                form.append("file", row.src1);
                row.src1 = (
                  await page.handleRequestMethods("uploadRemarks", form)
                ).payload;
              }
              if (row.src2) {
                page.openLoading();
                let form = new FormData();
                form.append("file", row.src2);
                row.src2 = (
                  await page.handleRequestMethods("uploadRemarks", form)
                ).payload;
              }
              page
                .handleRequestMethods("batchSetRemarks", row, true, true)
                .then(e => {
                  this.$refs["FREIGHT"].init();
                  close();
                });
            }
          },
          footer: {
            ok: {},
            cancel: {}
          },
          config: {
            formBind: {
              labelWidth: 100
            },
            rowBind: {
              gutter: 13,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              remarks: [
                {
                  required: true,
                  message: "Please Enter Remarks",
                  trigger: "blur"
                }
              ]
            }
          },
          grid: [{src1: 24}, {src2: 24}, {remarks: 24}],
          fields: [
            {
              key: "src1",
              name: () => this.$t("img") + " 1",
              component: "Upload",
              bind: {
                fileName: true,
                multiple: false,
                isButton: true,
                type: "select",
                accept: ".jpg,.jpge,.webp,.png"
              },
              methods: {
                beforeUpload({file, row, field}) {
                  row[field.key] = file;
                  return false;
                }
              }
            },
            {
              key: "src2",
              name: () => this.$t("img") + " 2",
              component: "Upload",
              bind: {
                fileName: true,
                multiple: false,
                isButton: true,
                type: "select",
                accept: ".jpg,.jpge,.webp,.png"
              },
              methods: {
                beforeUpload({file, row, field}) {
                  row[field.key] = file;
                  return false;
                }
              }
            },
            {
              key: "remarks",
              name: () => this.$t("Remarks"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("Remarks");
              },
              bind: {
                type: "textarea",
                rows: 5
              }
            }
          ]
        },
        setAgent: {
          methods: {
            ok({row, close}) {
              this.$page
                .handleRequestMethods(
                  "batchSetAgentNumber",
                  {...row, ids: this.$page.selectAll.map(t => t.id)},
                  true,
                  true
                )
                .then(res => {
                  close();
                });
            }
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true,
              sticky: true
            },
            formBind: {
              labelWidth: 100
            },
            title:
              this.$t("batch") +
              this.$t("setting") +
              this.$t("dingcangCompany"),
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            }
            // rules: {
            //   dingcang_company: [
            //     {
            //       required: true,
            //       type: "number",
            //       message: "dingcang company be empty",
            //       trigger: "bulr",
            //     },
            //   ],
            // },
          },
          grid: [{dingcang_company: 24}, {agent_number: 24}],
          fields: [
            {
              key: "agent_number",
              name: () => this.$t("order_refCode"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("order_refCode");
              }
            },
            {
              key: "dingcang_company",
              name: () => this.$t("dingcangCompany"),
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("dingcangCompany");
              },
              options: [],
              config: {
                label({row}) {
                  return row.code + "(" + row.alias + ")";
                },
                value: "id"
              },
              methods: {
                list: ({field}) => {
                  field.options = this.dingcang_company;
                }
              }
            }
          ]
        },
        openCost: {
          contentSlot: "cost",
          config: {
            modalBind: {
              width: 1550,
              transfer: true,
              draggable: true,
              sticky: true,
              "reset-drag-position": true,
              styles: {
                top: "30px"
              }
            },
            rules: {
              remarks: [
                {
                  required: true,
                  message: "remarks be empty",
                  trigger: "bulr"
                }
              ]
            },
            formBind: {
              labelWidth: 60
            },
            title: this.$t("add") + this.$t("order_desc"),
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            }
          },
          footer: {
            show: () => false
          }
        },
        modify: {
          methods: {
            ok({row, close}) {
              let postData = row
              postData['id'] = row['row']['id']
              delete postData['row']
              // 提交到后端从处理
              this.$page
                .handleRequestMethods(
                  "modifyShipments",
                  postData,
                  true,
                  true
                )
                .then(res => {
                  close();
                  this.$page.getList();
                });
            }
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true,
              sticky: true
            },
            formBind: {
              labelWidth: 100
            },
            title:
              this.$t("batch") +
              this.$t("setting") +
              this.$t("dingcangCompany"),
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            }
          },
          grid: [{consigneeName: 24}, {consigneeCity: 24}, {consigneeCellular: 24}, {consigneeAddress: 24}],
          fields: [
            {
              key: "consigneeName",
              name: () => '收件人名称',
              component: "Input",
              placeholder() {
                return this.$t("enter") + '收件人名称';
              },
              default: () => {
                return this.$store.state.app.currentShipmentParams.consignee_contact
              }
            },
            {
              key: "consigneeCity",
              name: () => '收件城市',
              component: "Select",
              options: [],
              placeholder() {
                return this.$t("enter") + '收件城市';
              },
              default: () => {
                return this.$store.state.app.currentShipmentParams.city_id
              },
              methods: {
                list: async ({field, row}) => {
                  field.options = (await getCountryCity(this.$store.state.app.currentShipmentParams.city_name, '', this.$store.state.app.currentShipmentParams.airway_number)).data.payload.rows;
                  row.consigneeCity = this.$store.state.app.currentShipmentParams.city_id
                  this.$forceUpdate();
                }
              }
            },
            {
              key: "consigneeCellular",
              name: () => '联系号码',
              component: "Input",
              placeholder() {
                return this.$t("enter") + '联系号码';
              },
              default: () => {
                return this.$store.state.app.currentShipmentParams.consignee_cellular
              }
            },
            {
              key: "consigneeAddress",
              name: () => '收件地址',
              component: "Input",
              placeholder() {
                return this.$t("enter") + '收件地址';
              },
              default: () => {
                return this.$store.state.app.currentShipmentParams.consignee_address
              }
            },
          ]
        },
        updateTransport: {
          methods: {
            ok({row, close}) {
              this.$page
                .handleRequestMethods("editTransport", row, true)
                .then(res => {
                  this.$page.getModal("update").list = res.payload;
                  close();
                });
            }
          },
          config: {
            rules: {
              transport_code: [
                {
                  required: true,
                  message: "transport be empty",
                  trigger: "bulr"
                }
              ],
              remarks: [
                {
                  required: true,
                  message: "remarks be empty",
                  trigger: "bulr"
                }
              ]
            },
            formBind: {
              labelWidth: 120
            },
            title: this.$t("add") + this.$t("order_desc"),
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            }
          },
          grid: [{transport_code: 24}, {remarks: 24}],
          fields: [
            {
              name: () => this.$t("method_code"),
              key: "transport_code",
              component: "Select",
              placeholder: () => this.$t("select") + this.$t("method_code"),
              options: [],
              config: {
                label({row}) {
                  return row.method_name + "(" + row.method_code + ")";
                },
                value: "method_code"
              },
              methods: {
                list: async ({field}) => {
                  field.options = (await getMethod()).data.payload.rows;
                  this.$forceUpdate();
                }
              }
            },
            {
              key: "remarks",
              name: () => this.$t("order_desc"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("order_desc");
              },
              bind: {
                type: "textarea",
                rows: 5
              }
            }
          ]
        },
        remark: {
          methods: {
            ok({row, close}) {
              this.$page
                .handleRequestMethods("addRemark", row, true)
                .then(res => {
                  this.$page
                    .handleRequestMethods(
                      "getGoodsInfo",
                      row.awbno,
                      false,
                      true
                    )
                    .then(res => {
                      this.$page.getModal("update").list = res.payload;
                      close();
                    });
                });
            }
          },
          config: {
            rules: {
              remarks: [
                {
                  required: true,
                  message: "remarks be empty",
                  trigger: "bulr"
                }
              ]
            },
            formBind: {
              labelWidth: 60
            },
            title: this.$t("add") + this.$t("order_desc"),
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            }
          },
          grid: [{remarks: 24}],
          fields: [
            {
              key: "remarks",
              name: () => this.$t("order_desc"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("order_desc");
              },
              bind: {
                type: "textarea",
                rows: 5
              }
            }
          ]
        },
        showDetails: {
          contentSlot: "DETAILS",
          config: {
            modalBind: {
              width: 1060,
              draggable: true,
              sticky: true
            }
          },
          footer: {
            show: () => false
          }
        },
        showStatus: {
          contentSlot: "STATUS",
          config: {
            modalBind: {
              width: 600,
              draggable: true,
              sticky: true
            }
          },
          footer: {
            show: () => false
          }
        },
        branchFeright: {
          contentSlot: "branchFright",
          methods: {
            ok: () => {
              this.$refs["branchFeright"].save();
            }
          },
          config: {
            modalBind: {
              width: 70,
              draggable: true,
              sticky: true,
              styles: {
                top: "50px"
              }
            }
            // modalContentBind: {
            //   style: {
            //     height: "650px"
            //   }
            // }
          },
          footer: {
            show: () => true
          }
        },
        showUnpack: {
          contentSlot: "UNPACK",
          config: {
            modalBind: {
              width: 900,
              draggable: true,
              sticky: true,
              styles: {
                top: "30px"
              }
            }
          },
          footer: {
            show: () => false
          }
        },
        showInfo: {
          contentSlot: "INFO",
          config: {
            modalBind: {
              width: 80,
              draggable: true,
              sticky: true,
              styles: {
                top: "30px"
              }
            }
          },
          footer: {
            show: () => false
          }
        },
        showFreight: {
          contentSlot: "FREIGHT",
          config: {
            modalBind: {
              width: 1550,
              transfer: true,
              draggable: true,
              sticky: true,
              "reset-drag-position": true,
              styles: {
                top: "30px"
              }
            }
          },
          methods: {
            // cancel() {
            //   this.$page.getList();
            // }
          },
          header: {
            show: () => true,
            copy: true,
            methods: {
              copy({row}) {
                copyClick.copyToClipboard(row.airway_number, this);
              }
            }
          },
          footer: {
            show: () => false
          },
          table: {
            height: 500
          }
        },
        showInbound: {
          contentSlot: "INBOUND",
          config: {
            modalBind: {
              width: 1600,
              transfer: true,
              draggable: true,
              sticky: true,
              "reset-drag-position": true
            }
          },
          header: {
            show: () => true,
            btns: [
              {
                name: () => this.$tz("导出"),
                type: "export",
                fnName: "export",
                bind: {
                  type: "primary"
                }
              }
            ],
            methods: {
              export: () => {
                console.log("export", this.$refs["inbound"]);
                let totalData = this.$refs["inbound"].totalData;
                let data = JSON.parse(
                  JSON.stringify(this.$refs["inbound"].tableData.data)
                );
                data.shift();
                let footer = [
                  "合计",
                  this.$t("inbound") + this.$t("caseNumber"),
                  totalData["quantity"] + "",
                  this.$t("skuVolume") + "(CBM)",
                  totalData["volume"] + "",
                  this.$t("actual_weight") + "(KG)",
                  totalData["actual_weight"] + "",
                  this.$t("charge_volume") + "(KG)",
                  totalData["volume_weight"] + ""
                ];
                data.push(
                  this.$refs["inbound"].tableTitle.reduce((a, b, i) => {
                    a[b.key] = footer[i] || "-";
                    return a;
                  }, {})
                );
                this.$refs["table"].exportExc({
                  fields: this.$refs["inbound"].tableTitle.map(t => {
                    return {
                      name: t.title === this.$tz("操作") ? "" : t.title,
                      key: t.key
                    };
                  }),
                  data,
                  name: this.$tz("入库")
                });
              }
            }
          },
          methods: {
            // close() {
            //   console.log(this);
            //   this.$page.getList();
            // }
            // cancel() {
            //   this.$page.getList();
            // }
          },

          footer: {
            show: () => false
          },
          table: {
            height: 500
          }
        },
        showOutbound: {
          contentSlot: "OUT",
          config: {
            modalBind: {
              width: 1300,
              transfer: true,
              draggable: true,
              sticky: true,
              "reset-drag-position": true
            }
          },
          methods: {
            // cancel() {
            //   this.$page.getList();
            // }
          },
          footer: {
            show: () => false
          },
          table: {
            height: 500
          }
        },
        update: {
          // contentSlot: "datails",
          config: {
            listFn: "getGoodsInfo",
            modalBind: {
              width: 800,
              transfer: true,
              draggable: true,
              sticky: true,
              "reset-drag-position": true
            }
          },
          methods: {
            // cancel() {
            //   this.$page.getList();
            // }
          },
          footer: {
            show: () => false
          },
          table: {
            config: {
              height: 600
            },
            fields: [
              {
                name: () => this.$t("shop_name"),
                key: "shop_name",
                minWidth: 100
              },
              {
                name: () => this.$t("cargo_number"),
                key: "cargo_number",
                minWidth: 100
              },
              {
                name: () => this.$t("case_number"),
                key: "caseNumber",
                component: "InputNumber",
                placeholder() {
                  return this.$t("enter") + this.$t("caseNumber");
                },
                bind: {
                  style: "width:100%"
                },
                minWidth: 100
              },
              {
                name: () => this.$t("outNumber"),
                key: "outNumber",
                component: "InputNumber",
                placeholder() {
                  return this.$t("outNumber");
                },
                bind: {
                  style: "width:100%"
                },
                minWidth: 100
              },
              {
                name: () => this.$t("order_desc"),
                key: "remarks",
                component: "a",
                minWidth: 100,
                methods: {
                  click({row}) {
                    this.$page.getModal("remark").open(row);
                  },
                  render: ({value}) => {
                    return value ? value : this.$t("addTo");
                  }
                }
              },
              {
                type: "btns",
                width: 150,
                name: () => this.$t("operation"),
                fixed: "right",
                // width({ field }) {
                //   return field.list.length * 40 + 40;
                // },
                list: [
                  {
                    name: () => this.$t("update"),
                    type: "update",
                    fnName: "update",
                    bind: {
                      type: "warning"
                    }
                  }
                ],
                methods: {
                  update({row}) {
                    let data = {
                      id: row.id,
                      caseNumber: row.caseNumber,
                      outNumber: row.outNumber
                    };
                    this.handleRequestMethods(
                      "saveGoodsInfo",
                      data,
                      true,
                      true
                    ).then(res => {
                      this.handleRequestMethods(
                        "getGoodsInfo",
                        row.awbno,
                        false,
                        true
                      ).then(res => {
                        this.getModal("update").list = res.payload;
                      });
                    });
                  }
                }
              }
            ]
          }
        },
        // 单个
        showPack: {
          // contentSlot: "PACK",
          type: "add",
          footer: {
            ok: {
              name: this.$t("order_submit"),
              id: 467
            },
            cancel: {}
          },
          methods: {
            ok({row}) {
              // if (!row.file) {
              //   this.$Message.error("请上传箱单文件");
              //   return false;
              // }
              // console.log("row", row, this);
              // this.postPacking;
              let formData = new FormData();
              row["airway_numbers[]"] = [row.id];

              for (let i in row) {
                formData.append(i, row[i]);
              }
              // let data = {
              //   formData,
              //   id: row.id
              // };
              this.pageConfig.loading = true;
              this.$page
                .handleRequestMethods("bachPack", formData, true)
                .then(result => {
                  this.$page
                    .handleRequestMethods("getPackList", {id: row.id})
                    .then(res => {
                      this.list = res.payload.list;
                      this.pageConfig.loading = false;

                      this.$refs["form"].formData["file"] = null;
                      this.$page.getList();
                    });
                })
                .catch(() => {
                  this.pageConfig.loading = false;
                });
            },
            cancel() {
            }
          },
          config: {
            listFn: "getPackList",
            modalBind: {
              width: 1000,
              transfer: true,
              draggable: true,
              sticky: true,
              "reset-drag-position": true
            },
            modalContentBind: {
              // style: {
              //   height: "600px"
              // }
            },
            formBind: {
              labelWidth: 130
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              // file: [
              //   {
              //     required: true,
              //     type: "object",
              //     message: "file type be empty",
              //     trigger: "change"
              //   }
              // ],
              deliver_type: [
                {
                  required: true,
                  type: "number",
                  message: "deliver type be empty",
                  trigger: "change"
                }
              ]
              // contact_mobile: [
              //   {
              //     required: true,
              //     message: "contact mobile be empty",
              //     trigger: "blur"
              //   }
              // ],
              // car_number: [
              //   {
              //     required: true,
              //     message: "car number be empty",
              //     trigger: "blur"
              //   }
              // ],
              // logistics_name: [
              //   {
              //     required: true,
              //     message: "logistics name be empty",
              //     trigger: "blur"
              //   }
              // ],
              // logistics_number: [
              //   {
              //     required: true,
              //     message: "logistics number be empty",
              //     trigger: "blur"
              //   }
              // ]
            }
          },
          grid: [
            {file: 12, is_solely: 12},
            {
              deliver_type: 8,
              contact_mobile: 8,
              contact_address: 8,
              send_mobile: 8,
              car_number: 8,
              logistics_name: 8,
              logistics_number: 8
            },
            {remarks: 24}
          ],
          fields: [
            {
              name: () => this.$t("updateFile") + this.$t("files"),
              key: "file",
              component: "Upload",
              bind: {
                fileName: true,
                multiple: false,
                isButton: true,
                type: "select",
                accept: ".xlsx,.xls"
              },
              methods: {
                beforeUpload({file, row}) {
                  row["file"] = file;
                  return false;
                }
              }
            },
            {
              name: () => this.$t("is_solely"),
              key: "is_solely",
              component: "Input",
              bind: {
                border: true
              },
              disabled: true
              // default(row) {
              //   console.log("row", row.formData);

              //   return row.formData.is_solely == "YES" ?this.$t('YES') : this.$t("NO");
              // }
              // methods: {
              //   async list({ row }) {
              //     console.log("row", arguments);
              //   }
              // render: ({ row }) => {
              //   return row.is_solely == "YES" ?this.$t('YES') : this.$t("NO");
              // }
              // }
              //   options: [
              //     { label: this.$t('YES'), value: "YES", disabled: () => true },
              //     { label: this.$t('NO'), value: "NO", disabled: () => true }
              //   ]
            },
            {
              name: () => this.$t("deliver") + this.$t("type"),
              key: "deliver_type",
              component: "Select",
              options: deliverList,
              default: 1,
              methods: {
                "on-change": ({row}) => {
                  for (let i in row) {
                    if (
                      i !== "deliver_type" &&
                      i !== "remarks" &&
                      i !== "file" &&
                      i !== "id"
                    ) {
                      row[i] = undefined;
                    }
                  }
                }
              }
            },
            {
              name: () => this.$t("Contact person"),
              key: "contact_mobile",
              component: "Input",

              placeholder: () => this.$t("enter") + this.$t("Contact person"),

              show: ({row}) => {
                return row.deliver_type == 1;
              }
            },
            {
              name: () => this.$t("pick up address"),
              key: "contact_address",
              component: "Input",

              placeholder: () => this.$t("enter") + this.$t("pick up address"),

              show: ({row}) => {
                return row.deliver_type == 1;
              }
            },
            {
              name: () => this.$t("deliverGoods") + this.$t("Contacts"),
              key: "send_mobile",
              component: "Input",
              placeholder: () =>
                this.$t("enter") +
                this.$t("deliverGoods") +
                this.$t("Contacts"),
              show: ({row}) => {
                return row.deliver_type == 2;
              }
            },
            {
              name: () => this.$t("deliverGoods") + this.$t("numberPlate"),
              key: "car_number",
              component: "Input",

              placeholder: () =>
                this.$t("enter") +
                this.$t("deliverGoods") +
                this.$t("numberPlate"),
              show: ({row}) => {
                return row.deliver_type == 2;
              }
            },
            {
              name: () => this.$t("ExpressLogisticsName"),
              key: "logistics_name",
              component: "Input",
              placeholder: () =>
                this.$t("entet") + this.$t("ExpressLogisticsName"),
              show: ({row}) => {
                return row.deliver_type == 3;
              }
            },
            {
              name: () => this.$t("ExpressLogisticsNumber"),
              key: "logistics_number",
              component: "Input",
              placeholder: () =>
                this.$t("entet") + this.$t("ExpressLogisticsNumber"),
              show: ({row}) => {
                return row.deliver_type == 3;
              }
            },
            {
              name: () => this.$t("Remarks"),
              key: "remarks",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("Remarks"),
              bind: {
                type: "textarea",
                rows: 4
              }
            }
          ],
          table: {
            config: {
              height: 350
            },
            fields: [
              {
                name: () => this.$t("order_number"),
                key: "airway_bill_number",

                minWidth: 100
              },
              {
                name: () => this.$t("download") + this.$t("address"),

                key: "down_url",
                minWidth: 60,
                render(h, {row}) {
                  return h(
                    "Button",
                    {
                      props: {
                        type: "warning",
                        size: "small"
                      },
                      on: {
                        click: () => {
                          this.$page.handleRequestMethods(
                            "readPackBox",
                            row.id
                          );
                          this.$page.openUrl(row.src);
                        }
                      }
                    },
                    this.$t("download")
                  );
                }
              },
              {
                name: () => this.$t("preview") + this.$t("address"),

                key: "preview_url",
                minWidth: 60,
                render(h, {row}) {
                  return h(
                    "Button",
                    {
                      props: {
                        type: "warning",
                        size: "small"
                      },
                      on: {
                        click: () => {
                          this.$page.handleRequestMethods(
                            "readPackBox",
                            row.id
                          );
                          window.open(
                            //"https://view.officeapps.live.com/op/view.aspx?src=" +
                            this.$page.openUrl(row.src, 1),
                            "_blank"
                          );
                        }
                      }
                    },
                    this.$t("preview")
                  );
                }
              },
              {
                name: () => this.$t("operate"),

                key: "operator_name",
                minWidth: 110
              },
              {
                name: () => this.$t("createTime"),

                key: "create_time",
                minWidth: 110
              },
              {
                name: () => this.$t("auditOrder") + this.$t("exlType"),

                key: "verify",
                minWidth: 110,
                methods: {
                  render: ({row}) => {
                    return row.verify === 1
                      ? this.$t("pass")
                      : this.$t("noPass");
                  }
                },
                render(h, params) {
                  return h(
                    "div",
                    {
                      style: {
                        color: params.row.verify === 1 ? "#19b16b" : "#f5222d"
                      }
                    },
                    params.row.verify === 1
                      ? this.$t("pass")
                      : this.$t("noPass")
                  );
                }
              },
              {
                type: "btns",
                width: 130,
                name: () => this.$t("operation"),
                fixed: "right",

                id: 533,
                btnBind: {
                  type: "primary",
                  size: "small",
                  transfer: true
                },
                show: ({row}) => {
                  return this.$refs["table"].getModal("showPack").params
                    .is_verify;
                },
                list: [
                  {
                    name: () => this.$t("auditOrder") + this.$t("pass"),
                    type: "pass",
                    fnName: "passFun",
                    bind: {
                      type: "primary"
                    },
                    show({row}) {
                      return row.verify === 2;
                    }
                  },
                  {
                    name: () => this.$t("auditOrder") + this.$t("noPass"),
                    type: "noPass",
                    fnName: "passFun",
                    bind: {
                      type: "primary"
                    },
                    show({row}) {
                      return row.verify === 1;
                    }
                  }
                ],
                methods: {
                  passFun({row}) {
                    this.handleRequestMethods(
                      "getAuditList",
                      row.id,
                      true
                    ).then(res => {
                      this.getModal("showPack").getList();
                    });
                  }
                }
              }
            ]
          }
        },
        showService: {
          // contentSlot: "PACK",
          methods: {
            ok({row}) {
              this.$page
                .handleRequestMethods("batchService", row, false, true)
                .then(result => {
                  this.$page.getList();
                  this.close();
                });
            }
          },
          config: {
            modalBind: {
              width: 600,
              transfer: true,
              draggable: true,
              sticky: true,
              "reset-drag-position": true
            },
            modalContentBind: {
              // style: {
              //   height: "600px"
              // }
            },
            formBind: {
              labelWidth: 130
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              service_code: [
                {
                  required: true,
                  message: "service type be empty",
                  trigger: "change"
                }
              ],
              remarks: [
                {
                  required: true,
                  message: "remarks type be empty",
                  trigger: "blur"
                }
              ]
            }
          },
          grid: [{service_code: 24}, {remarks: 24}],
          fields: [
            {
              name: () => this.$t("company"),
              key: "service_code",
              component: "Select",
              options: [],
              placeholder() {
                return this.$t("select") + this.$t("company");
              },
              options: [],
              config: {
                label({row}) {
                  return row[
                    this.$i18n.locale === "zh-CN"
                      ? "service_name"
                      : "service_name_en"
                    ];
                },
                value: "service_code"
              },
              methods: {
                async list({field, searchForm}) {
                  field.options = (await getService()).data.payload;
                  this.$forceUpdate();
                }
              }
            },
            {
              name: () => this.$t("Remarks"),
              key: "remarks",
              component: "Input",
              bind: {
                type: "textarea",
                rows: 4,
                placeholder: this.$t("Remarks")
              }
            }
          ]
        },
        // 批量
        showBachPack: {
          // contentSlot: "PACK",
          footer: {
            ok: {
              name: this.$t("order_submit"),
              id: 467
            },
            cancel: {}
          },
          methods: {
            ok({row}) {
              row["airway_numbers"] = this.$page.selectAll.map(
                item => item.airway_number
              );
              let formData = new FormData();
              for (let i in row) {
                if (i == "airway_numbers") {
                  row[i].forEach(item => {
                    formData.append("airway_numbers[]", item);
                  });
                } else {
                  formData.append(i, row[i]);
                }
              }
              this.$page
                .handleRequestMethods("bachPack", formData, false, true)
                .then(result => {
                  this.$page.getList();
                  this.close();
                });
            },
            cancel() {
            }
          },
          config: {
            modalBind: {
              width: 600,
              transfer: true,
              draggable: true,
              sticky: true,
              "reset-drag-position": true
            },
            modalContentBind: {
              // style: {
              //   height: "600px"
              // }
            },
            formBind: {
              labelWidth: 130
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              // file: [
              //   {
              //     required: true,
              //     type: "object",
              //     message: "file type be empty",
              //     trigger: "change"
              //   }
              // ],
              deliver_type: [
                {
                  required: true,
                  type: "number",
                  message: "deliver type be empty",
                  trigger: "change"
                }
              ]
              // contact_mobile: [
              //   {
              //     required: true,
              //     message: "contact mobile be empty",
              //     trigger: "blur"
              //   }
              // ],
              // car_number: [
              //   {
              //     required: true,
              //     message: "car number be empty",
              //     trigger: "blur"
              //   }
              // ],
              // logistics_name: [
              //   {
              //     required: true,
              //     message: "logistics name be empty",
              //     trigger: "blur"
              //   }
              // ],
              // logistics_number: [
              //   {
              //     required: true,
              //     message: "logistics number be empty",
              //     trigger: "blur"
              //   }
              // ]
            }
          },
          grid: [
            {deliver_type: 24},
            {contact_mobile: 24},
            {contact_address: 24},
            {send_mobile: 24},
            {car_number: 24},
            {logistics_name: 24},
            {logistics_number: 24},
            {remarks: 24}
          ],
          fields: [
            {
              name: () => this.$t("updateFile") + this.$t("files"),
              key: "file",
              component: "Upload",
              bind: {
                fileName: true,
                multiple: false,
                isButton: true,
                type: "select",
                accept: ".xlsx,.xls"
              },
              methods: {
                beforeUpload({file, row}) {
                  row["file"] = file;
                  console.log(this);
                  return false;
                }
              }
            },
            {
              name: () => this.$t("The delivery type"),
              key: "deliver_type",
              component: "Select",
              options: deliverList,
              default: 1,
              methods: {
                "on-change": ({row}) => {
                  for (let i in row) {
                    if (
                      i !== "deliver_type" &&
                      i !== "remarks" &&
                      i !== "file" &&
                      i !== "id"
                    ) {
                      row[i] = undefined;
                    }
                  }
                }
              }
            },
            {
              name: () => this.$t("Contact person"),
              key: "contact_mobile",
              component: "Input",
              placeholder: this.$t("enter") + this.$t("Contact person"),
              show: ({row}) => {
                return row.deliver_type == 1;
              }
            },
            {
              name: () => this.$t("pick up address"),
              key: "contact_address",
              component: "Input",
              placeholder: this.$t("enter") + this.$t("pick up address"),
              show: ({row}) => {
                return row.deliver_type == 1;
              }
            },
            {
              name: () => this.$t("deliverGoods") + this.$t("Contacts"),
              key: "send_mobile",
              component: "Input",
              placeholder:
                this.$t("enter") +
                this.$t("deliverGoods") +
                this.$t("Contacts"),
              show: ({row}) => {
                return row.deliver_type == 2;
              }
            },
            {
              name: () => this.$t("deliverGoods") + this.$t("numberPlate"),
              key: "car_number",
              component: "Input",
              placeholder:
                this.$t("enter") +
                this.$t("deliverGoods") +
                this.$t("numberPlate"),
              show: ({row}) => {
                return row.deliver_type == 2;
              }
            },
            {
              name: () => this.$t("ExpressLogisticsName"),
              key: "logistics_name",
              component: "Input",
              placeholder: this.$t("entet") + this.$t("ExpressLogisticsName"),
              show: ({row}) => {
                return row.deliver_type == 3;
              }
            },
            {
              name: () => this.$t("ExpressLogisticsNumber"),
              key: "logistics_number",
              component: "Input",
              placeholder: this.$t("entet") + this.$t("ExpressLogisticsNumber"),
              show: ({row}) => {
                return row.deliver_type == 3;
              }
            },
            {
              name: () => this.$t("Remarks"),
              key: "remarks",
              component: "Input",
              bind: {
                type: "textarea",
                rows: 4,
                placeholder: this.$t("Remarks")
              }
            }
          ]
        },

        modalAdd: {
          config: {
            modalBind: {
              width: 600,
              draggable: true,
              maskClosable: false
            },
            formBind: {
              labelWidth: 100
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            }
          },
          footer: {
            show: () => true
          },
          methods: {
            ok({row, close}) {
              let data = row;
              data.id = row.id;
              let text =
                this.$page.getModal("modalAdd").type == "update"
                  ? "updateRules"
                  : "createRules";
              this.$page.handleRequestMethods(text, data).then(res => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg
                });
                this.$page
                  .handleRequestMethods(
                    "rulesList",
                    this.$page.getModal("showDetails").params.row.id
                  )
                  .then(res => {
                    this.$page.getModal("showDetails").list = res.payload;
                  });

                close();
              });
            }
          }
        },
        add: {
          methods: {
            ok({row, close}) {
              let data = {};
              this.$refs["form"].filterFields.forEach(
                item => (data[item.key] = row[item.key])
              );
              data.id = row.id;
              this.$page.handleRequestMethods(this.type, data).then(res => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg
                });
                this.$page.getList();
                close();
              });
            }
          },
          footer: {
            show: () => false
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true,
              maskClosable: false
            },
            title: this.$t("changeOrder"),
            modalContentBind: {
              style: {
                height: "250px"
              }
            },
            formBind: {
              labelWidth: 120
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              airway_number: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "change"
                }
              ]
            }
          },
          grid: [{airway_number: 24}, {msg: 24}],
          fields: [
            {
              name: () => this.$t("order_number"),
              key: "airway_number",
              component: "Input",
              methods: {
                "on-enter": ({formData}) => {
                  changeSheet(formData).then(res => {
                    this.playaudio(res.data.payload.voice);
                    formData.airway_number = "";
                    if (res.data.status) {
                      formData.msg = res.data.payload.airway_number;
                      jsonp(
                        `http://127.0.0.1:10801/?orderSN=${res.data.payload.airway_number}&mini=no`,
                        {
                          Accept: "application/json",
                          "Content-Type": "application/json"
                        },
                        (err, data) => {
                          console.log(err);
                          console.log(data);
                        }
                      );
                    } else {
                      formData.msg = res.data.msg;
                    }
                  });
                  // console.log(formData);
                  // formData.airway_number = "";
                  // formData.msg = 123412;
                  // formData.status = true;
                  // fields.forEach(async field => {
                  //   if (field.key === "client_id") {
                  //     if (formData.account_type == 1) {
                  //       field.options = (
                  //         await this.$page.handleRequestMethods("getAllClient")
                  //       ).payload.rows;
                  //     } else {
                  //       field.options = (
                  //         await this.$page.handleRequestMethods("getConfig")
                  //       ).payload.company.map(item => {
                  //         return { account: item.value, id: item.key };
                  //       });
                  //     }
                  //   }
                  // });
                }
              }
            },
            {
              name: () => this.$t("tip1"),
              key: "msg",
              disabled: true,
              show({formData}) {
                return formData.msg != "";
              },
              render(h, p) {
                return h(
                  "span",
                  {
                    style: {
                      color: p.row.status ? "green" : "red"
                    }
                  },
                  p.row.msg
                );
              }
            }
          ]
        },
        upload: {
          footer: {
            ok: {
              name: () => this.$t("updateFile"),
              id: 431
            },
            cancel: {}
          },
          methods: {
            ok({list}) {
              console.log(list);
              this.$page.getModal("upload").disabledConfirm = true;
              let data = new FormData();
              for (var i = 0; i < list.length; i++) {
                data.append("files[]", list[i]); // 文件对象
              }
              this.$page.handleRequestMethods("uploadFiles", data).then(res => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg
                });
                this.$page.getModal("upload").disabledConfirm = false;
                this.$page.getModal("upload").list = res.payload;
                this.$page.getList();
              });
            }
          },
          // btns: {
          //   list: [
          //     {
          //       name: "NOON 装箱单 PL",
          //       type: "1",
          //       url: "/static/templates/NOONPackingList.xlsx",
          //       fnName: "down",
          //       size: "small",
          //       bind: {
          //         type: "primary"
          //       }
          //     },
          //     {
          //       name: "FBA 装箱单 PL",
          //       type: "2",
          //       url: "/static/templates/FBAPackingList.xlsx",
          //       fnName: "down",
          //       size: "small",
          //       bind: {
          //         type: "primary"
          //       }
          //     },
          //     {
          //       name: "海外仓上架随货清单",
          //       type: "3",
          //       url: "/static/templates/WMSPutShelf.xlsx",
          //       fnName: "down",
          //       size: "small",
          //       bind: {
          //         type: "primary"
          //       }
          //     }
          //   ],
          //   methods: {
          //     down({ field }) {
          //       window.open(this.$globalUrl + field.url);
          //     }
          //   }
          // },
          config: {
            modalBind: {
              width: 800,
              draggable: true,
              maskClosable: false
            },
            modalContentBind: {
              style: {
                height: "500px"
              }
            },
            // formBind: {
            //   labelWidth: 120
            // },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            }
          },
          grid: [{files: 24}],
          fields: [
            {
              key: "files",
              component: "Upload",
              bind: {
                type: "drag",
                accept: ".xlsx,.xls"
              },
              methods: {
                beforeUpload: ({file}) => {
                  this.$refs["table"].getModal("upload").list.push(file);
                  this.$refs["table"].getModal(
                    "upload"
                  ).disabledConfirm = false;
                  return false;
                }
              }
            }
          ],
          table: {
            config: {
              height: 300
            },
            fields: [
              {
                name: () => this.$t("fileName"),
                key: "name",

                minWidth: 140
              },
              {
                name: () => this.$t("updateFile") + this.$t("exlType"),

                key: "status",
                minWidth: 80,
                render(h, {row}) {
                  console.log("row", row);

                  return h(
                    "span",
                    {
                      style: {
                        color:
                          row.status != undefined
                            ? row.status
                              ? "green"
                              : "red"
                            : "blue"
                      }
                    },
                    row.status != undefined
                      ? row.status
                        ? this.$t("updateFile") + this.$t("success")
                        : this.$t("updateFile") + this.$t("error")
                      : this.$t("preparing")
                  );
                }
              },
              {
                name: () => this.$t("tip1"),

                key: "msg",
                minWidth: 110
              },
              {
                name: () => this.$t("operate"),

                key: "user",
                minWidth: 110
              },
              {
                name: () => this.$t("updateFile") + this.$t("date"),

                key: "date",
                minWidth: 170
              },
              {
                name: () => this.$t("operation"),

                width: 60,
                render(h, {row, index}) {
                  return h("Icon", {
                    props: {type: row && !row.status ? "md-trash" : ""},
                    on: {
                      click: () => {
                        if (row && !row.status) this.list.splice(index, 1);
                      }
                    }
                  });
                }
              }
            ]
          }
        },
        showUpload: {
          contentSlot: "UPLOAD",
          config: {
            modalBind: {
              width: 600,
              draggable: true,
              sticky: true
            },
            title: this.$t("Upload doc")
          },
          footer: {
            show: () => false
          }
        },
        ortherCost: {
          methods: {
            ok({row, close}) {
              this.$page
                .handleRequestMethods("saveService", row, true, true)
                .then(e => {
                  this.$page.getList();
                  close();
                });
            }
          },
          footer: {
            ok: {},
            cancel: {}
          },
          config: {
            title: () => this.$t("addValueService"),
            modalBind: {
              width: 600
            },
            formBind: {
              labelWidth: 100
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              service_id: [
                {
                  required: true,
                  message: "plan cannot be empty",
                  trigger: "change",
                  type: "number"
                }
              ],
              quantity: [
                {
                  required: true,
                  message: "plan cannot be empty",
                  trigger: "blur",
                  type: "number"
                }
              ]
            }
          },
          grid: [
            {
              service_id: 24
            },
            {
              quantity: 24
            }
          ],
          fields: [
            {
              key: "service_id",
              name: () => this.$t("valueService"),
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("valueService");
              },
              options: [],
              methods: {
                async list({field, searchForm}) {
                  let res = (
                    await this.$page.handleRequestMethods("getWhService")
                  ).payload;
                  field.options = res;
                  this.$forceUpdate();
                }
              }
            },
            {
              name: () => this.$t("Billing") + this.$t("noofpieces"),
              key: "quantity",
              component: "InputNumber",
              placeholder() {
                return (
                  this.$t("enter") + this.$t("Billing") + this.$t("noofpieces")
                );
              },
              default: 0,
              bind: {
                style: "width:100%",
                min: 0
              }
            }
          ]
        },
        ortherCostList: {
          config: {
            modalBind: {
              width: 60
            },
            title: "order_desc",
            modalContentBind: {
              style: "height:60vh;overflow-x:hidden;overflow-y:auto;"
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            }
          },
          footer: {
            show: false
          },
          fields: [],
          table: {
            config: {
              align: "center",
              height: 500
            },
            fields: [
              {
                name: () => this.$t("valueService") + this.$t("alipay_name"),
                key: "service_name",
                minWidth: 100
              },
              {
                name: () => this.$t("Billing") + this.$t("noofpieces"),
                key: "quantity",
                align: "center",
                width: 100,
                render: (h, { row }) => {
                  if (!this.currentEditElementId || row.id !== this.currentEditElementId) {
                    return h('span', {}, row.quantity)
                  } else {
                    return h('Input', {
                      props: {
                        value: row.quantity,
                        size: 'small'
                      },
                      on: {
                        'on-change': (val) => {
                          // 检查是否数字
                          if (/^[1-9]\d*$/.test(val.target.value)) {
                            row.total_amount = val.target.value * row.price
                            row.quantity = val.target.value
                          } else {
                            this.$Message.error('请输入大于0的整数')
                          }

                        }
                      }
                    })
                  }
                }
              },
              {
                name: () => this.$t("valueService") + this.$t("cost_t"),
                key: "total_amount",
                align: "center",
                width: 110
              },
              {
                name: () => this.$t("operate"),
                key: "create_name",
                align: "center",
                width: 100
              },
              {
                name: () => this.$t("operation") + this.$t("time"),
                key: "create_time",
                align: "center",
                width: 150
              },
              {
                name: () => '操作',
                key: "updateItem",
                align: "center",
                width: 150,
                render: (h, { row }) => {
                  if (this.currentEditElementId && row.id === this.currentEditElementId) {
                    // 提交数据
                    return h('Button', {
                      props: {
                        type: 'success',
                        size: 'small'
                      },
                      on: {
                        click: () => {
                          upgradeFeesItem(row).then(res => {
                            this.currentEditElementId = 0
                          })
                        }
                      }
                    }, '保存数据')
                  } else {
                    return h('div', {}, [
                      h('Button', {
                        props: {
                          type: 'primary',
                          size: 'small'
                        },
                        style: {
                          marginRight: '5px'
                        },
                        on: {
                          click: () => {
                            this.currentEditElementId = row.id;
                          }
                        }
                      }, '编辑数据'),
                      h('Button', {
                        props: {
                          type: 'error',
                          size: 'small'
                        },
                        on: {
                          click: () => {
                            this.$Modal.confirm({
                              title: '删除操作确认',
                              content: '<p>确定是否删除该条记录?</p>',
                              onOk: () => {
                                removeFeesItem(row).then(res => {
                                  this.$Message.success('费用删除成功, 请关闭后刷新数据')
                                })
                              }
                            })
                          }
                        }
                      }, '删除数据')
                    ])
                  }

                }
              }
            ]
          }
        },
        // 批量更新轨迹
        updateTrace: {
          methods: {
            ok({row, close}) {
              row["trace_time"] = row["trace_time"].split(" ")[0];
              this.$page
                .handleRequestMethods("batchUpdateTrack", row, true)
                .then(e => {
                  this.$page.getList();
                  close();
                });
            }
          },
          footer: {
            ok: {},
            cancel: {}
          },
          config: {
            title: () => this.$t("updateTrace"),
            modalBind: {
              width: 600
            },
            formBind: {
              labelWidth: 120
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              country_id: [
                {
                  required: true,
                  message: "plan cannot be empty",
                  trigger: "change",
                  type: "number"
                }
              ],
              city: [
                {
                  required: true,
                  message: "plan cannot be empty",
                  trigger: "change",
                  type: "number"
                }
              ],
              trace_code: [
                {
                  required: true,
                  message: "plan cannot be empty",
                  trigger: "change"
                }
              ],
              trace_time: [
                {
                  required: true,
                  message: "plan cannot be empty",
                  trigger: "change",
                  type: "date"
                }
              ],
              time: [
                {
                  required: true,
                  message: "plan cannot be empty",
                  trigger: "change",
                  type: "date"
                }
              ]
            }
          },
          grid: [
            {
              country_id: 24
            },
            {
              city: 24
            },
            {
              trace_code: 24
            },
            {
              trace_time: 24
            },
            {
              time: 24
            }
          ],
          fields: [
            {
              key: "country_id",
              name: () => this.$t("countryName"),
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("countryName");
              },
              options: [],
              config: {
                label: "title",
                value: "id"
              },
              methods: {
                async "on-change"({value, field, fields, row}) {
                  fields.forEach(async el => {
                    if (el.key == "city") {
                      if (value) {
                        let res = (await getCity({country_id: value})).data
                          .payload.rows;
                        el.options = res;
                      } else {
                        el.options = [];
                      }
                      row[el.key] = "";
                      this.$forceUpdate();
                      return;
                    }
                  });
                }
              }
            },
            {
              key: "city",
              name: () => this.$t("city_name"),
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("city_name");
              },
              options: [],
              disabled: ({row}) => {
                return !row.country_id;
              },
              config: {
                label: "title",
                value: "id"
              }
            },
            {
              key: "trace_code",
              name: () => this.$t("tracker_code"),
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("tracker_code");
              },
              options: []
              // config: {
              //   label: "tracker_code",
              //   value: "tracker_code",
              // },
            },
            {
              key: "trace_time",
              name: () => this.$t("Process Info Time"),
              component: "DatePicker",
              disabledDate: true,
              placeholder() {
                return this.$t("select") + this.$t("Process Info Time");
              },
              bind: {
                type: "date"
              },
              show({formData}) {
                return ["ETD", "ETA"].includes(formData["trace_code"]);
              }
            },
            {
              key: "time",
              name: () => this.$t("upTime"),
              component: "DatePicker",
              disabledDate: true,
              placeholder() {
                return this.$t("select") + this.$t("upTime");
              },
              bind: {
                type: "datetime"
              }
            }
          ]
        },
        log: {
          config: {
            modalBind: {
              width: 60
            },
            modalContentBind: {
              style: "height:60vh;overflow-x:hidden;overflow-y:auto;"
            }
          },
          footer: {
            show: false
          },
          fields: [],
          table: {
            config: {
              align: "center",
              height: 500
            },
            fields: [
              {
                name: () => this.$t("type"),
                key: "type",
                width: 100
              },
              {
                name: () => this.$t("operate"),
                key: "name",
                align: "center",
                width: 150
              },
              {
                name: () => this.$t("operation time"),
                key: "create_time",
                align: "center",
                width: 150
              },
              {
                name: () => this.$t("operation content"),
                key: "msg",
                align: "center",
                minWidth: 110
              }
            ]
          }
        }
      },
      header: {
        searchs: [
          {
            key: "dateType",
            placeholder() {
              return this.$t("select") + this.$t("date") + this.$t("type");
            },
            component: "Select",
            options: [],
            methods: {
              async list({field, searchForm}) {
                let res = (await getSelectType(["CLEARANCE_SELECT"])).data
                  .payload["CLEARANCE_SELECT"];
                field.options = res;
                searchForm[field.key] = res[0].value;
                this.$forceUpdate();
              }
            }
          },
          {
            key: "startTime",
            component: "DatePicker",
            placeholder() {
              return this.$t("start") + this.$t("date") + this.$t("time");
            },
            bind: {
              type: "datetime",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              style: {
                width: "175px"
              }
            },
            methods: {
              "on-change"({searchForm}) {
                searchForm.startTime = searchForm.startTime
                  ? this.$page.format.timeFormat(searchForm.startTime)
                  : "";
              }
            }
          },
          {
            key: "endTime",
            component: "DatePicker",
            placeholder() {
              return this.$t("end") + this.$t("date") + this.$t("time");
            },
            bind: {
              type: "datetime",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              style: {
                width: "175px"
              }
            },
            methods: {
              "on-change"({searchForm}) {
                let time = this.$page.format.timeFormat(searchForm.endTime);
                if (time.slice(-8) === "00:00:00") {
                  time = time.split(" ")[0] + " " + "23:59:59";
                  searchForm.endTime = time;
                }
              }
            }
          },
          {
            key: "client_id",
            component: "AutoComplete",
            placeholder() {
              return '客户账号';
            },
            clearable: true,
            // options: [],
            // config: {label: "account", value: "id"},
            bind: {
              style: "width:150px"
            },
            data: [],
            onSearch: ({value, item}) => {
              if (value.length >= 2) {
                searchCustomer(value).then(res => {
                  item.data = res.data.payload
                })
              }
            }
          },
          {
            key: "ownership",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("ownership");
            },
            clearable: true,
            options: [],
            config: {label: "title", value: "id"},
            bind: {
              style: "width:150px"
            },
            methods: {
              async list({field, searchForm}) {
                let res = (await getCompanies()).data.payload;
                field.options = res;
                this.$forceUpdate();
              }
            }
          },
          {
            key: "dbl_service",
            component: "Select",
            placeholder() {
              return this.$t("双清客服账号");
            },
            // clearable: true,
            options: [],
            filterable: false,
            bind: {
              style: "width:150px",
            }
          },
          {
            key: "seller",
            component: "Select",
            placeholder() {
              return this.$t("salesman");
            },
            clearable: true,
            options: [],
            config: {label: "account", value: "id"},
            bind: {
              style: "width:150px"
            }
          },
          {
            key: "packageSize",
            component: "Select",
            placeholder() {
              return '大包状态';
            },
            clearable: true,
            options: [],
            bind: {
              style: "width:150px"
            }
          },
          {
            key: "paymentStatus",
            component: "Select",
            placeholder() {
              return '支付状态';
            },
            clearable: true,
            options: [{label: '已支付', value: 'YES'}, {label: '未支付', value: 'NO'}],
            bind: {
              style: "width:150px"
            }
          },
          {
            key: "formCountry",
            placeholder() {
              return this.$tz("起运国");
            },
            component: "Select",
            options: [],
            optionsFn: "formCountry",
            optionsKey: ""
          },
          {
            key: "toCountry",
            placeholder() {
              return this.$tz("目的国");
            },
            component: "Select",
            options: [],
            optionsFn: "toCountry",
            optionsKey: ""
          },
          {
            key: "dbl_status",
            component: "Select",
            placeholder() {
              return this.$t("cod_status");
            },
            clearable: true,
            options: [],
            bind: {
              style: "width:120px"
            }
          },
          {
            key: "isUnpack",
            component: "Select",
            placeholder() {
              return this.$t("isUnpack");
            },
            clearable: true,
            options: [
              {label: this.$t("YES"), value: "YES"},
              {label: this.$t("NO"), value: "NO"}
            ],
            bind: {
              style: "width:120px"
            }
          },
          {
            key: "is_unpack_finish",
            component: "Select",
            placeholder() {
              return this.$t("isUnpack") + this.$t("complete");
            },
            clearable: true,
            options: [
              {label: this.$t("YES"), value: "YES"},
              {label: this.$t("NO"), value: "NO"}
            ],
            bind: {
              style: "width:120px"
            }
          },
          {
            key: "confirmed",
            component: "Select",
            placeholder() {
              return this.$t("whether") + this.$t("doubleFeright");
            },
            clearable: true,
            options: [
              {label: this.$t("YES"), value: "YES"},
              {label: this.$t("NO"), value: "NO"}
            ],
            bind: {
              style: "width:120px"
            }
          },
          {
            key: "branch_finance",
            component: "Select",
            placeholder() {
              return this.$tz("分公司,是否,报价");
            },
            clearable: true,
            options: [
              {label: this.$t("YES"), value: "YES"},
              {label: this.$t("NO"), value: "NO"}
            ],
            bind: {
              style: "width:140px"
            }
          },
          {
            key: "finance",
            component: "Select",
            placeholder() {
              return this.$t("whether") + this.$t("bindFreight");
            },
            clearable: true,
            options: [
              {label: this.$t("YES"), value: "YES"},
              {label: this.$t("NO"), value: "NO"}
            ],
            bind: {
              style: "width:100px"
            }
          },
          {
            key: "is_solely",
            component: "Select",
            placeholder() {
              return this.$t("is_solely");
            },
            clearable: true,
            options: [
              {label: this.$t("YES"), value: "YES"},
              {label: this.$t("NO"), value: "NO"}
            ],
            bind: {
              style: "width:100px"
            },
            show: () => {
              return this.tabName != "solelyOrder";
            }
          },
          {
            key: "isVerify",
            component: "Select",
            placeholder() {
              return this.$t("boxOrder") + this.$t("auditOrder");
            },
            clearable: true,
            options: [
              {label: this.$t("YES"), value: "YES"},
              {label: this.$t("NO"), value: "NO"}
            ],
            bind: {
              style: "width:100px"
            }
          },
          {
            key: "inboundStatus",
            component: "Select",
            placeholder() {
              return this.$t("inboundStatus");
            },
            clearable: true,
            options: [
              {label: this.$t("YES"), value: "YES"},
              {label: this.$t("NO"), value: "NO"}
            ],
            bind: {
              style: "width:100px"
            }
          },
          {
            key: "in_warehouse",
            component: "Select",
            placeholder() {
              return this.$t("whether") + this.$t("inbound");
            },
            clearable: true,
            options: [],
            bind: {
              style: "width:100px"
            }
          },
          {
            key: "out_warehouse",
            component: "Select",
            placeholder() {
              return this.$t("whether") + this.$t("outbound");
            },
            clearable: true,
            options: [],
            bind: {
              style: "width:100px"
            }
          },
          {
            key: "track_status",
            component: "Select",
            placeholder() {
              return this.$t("orderType");
            },
            clearable: true,
            options: [],
            bind: {
              style: "width:100px"
            }
          },
          {
            key: "isConfirmed",
            component: "Select",
            placeholder() {
              return this.$t("confirm") + this.$t("Weight");
            },
            clearable: true,
            options: [
              {label: this.$t("YES"), value: "YES"},
              {label: this.$t("NO"), value: "NO"}
            ],
            bind: {
              style: "width:100px"
            }
          },
          {
            key: "transport_code",
            component: "Select",
            options: [],
            bind: {
              style: {
                width: "130px"
              }
            },
            config: {
              label({row}) {
                return row.method_name + "(" + row.method_code + ")";
              },
              value: "method_code"
            },
            placeholder() {
              return this.$t("method_name");
            },
            methods: {
              async list({field}) {
                field.options = (await getMethod()).data.payload.rows;
                this.$forceUpdate();
              }
            }
          },
          {
            key: "dingcang_company",
            component: "Select",
            options: [],
            bind: {
              style: {
                width: "130px"
              }
            },
            config: {
              label({row}) {
                return row.code + "(" + row.alias + ")";
              },
              value: "id"
            },
            placeholder() {
              return this.$t("dingcangCompany");
            }
          },
          {
            key: "is_pod",
            component: "Select",
            placeholder() {
              return this.$t("is_pod");
            },
            clearable: true,
            options: [
              {label: this.$t("YES"), value: "YES"},
              {label: this.$t("NO"), value: "NO"}
            ],
            bind: {
              style: "width:100px"
            }
          },
          {
            key: "abnormal",
            component: "Select",
            placeholder() {
              return this.$t("是否异常");
            },
            clearable: true,
            options: [
              {label: this.$t("YES"), value: "YES"},
              {label: this.$t("NO"), value: "NO"}
            ],
            bind: {
              style: "width:100px"
            }
          },
          {
            key: "service_code",
            component: "Select",
            bind: {
              style: "width:150px"
            },
            placeholder() {
              return this.$t("select") + this.$t("company");
            },
            options: [],
            config: {
              label: "service_name",
              value: "service_code"
            },
            methods: {
              async list({field, searchForm}) {
                field.options = (await getService()).data.payload;
                this.$forceUpdate();
              }
            }
          },
          {
            key: "service_type",
            component: "Select",
            bind: {
              style: "width:150px"
            },
            placeholder() {
              return this.$t("select") + this.$t("valueService");
            },
            options: [],
            methods: {
              async list({field, searchForm}) {
                let res = (
                  await this.$page.handleRequestMethods("getWhService")
                ).payload;
                field.options = res;
                this.$forceUpdate();
              }
            }
          },

          {
            key: "department",
            placeholder() {
              return this.$tz("部门");
            },
            component: "Select",
            options: [
              // 2-平台组，3-空运部
              {label: this.$tz("平台组"), value: 2},
              {label: this.$tz("空运部"), value: 3}
            ],
            optionsFn: "",
            optionsKey: ""
          },
          {
            key: "is_bill",
            placeholder() {
              return this.$tz("是否,出账单");
            },
            component: "Select",
            options: [],
            optionsFn: "YesNo",
            optionsKey: ""
          },
          {
            key: "keywordsType",
            component: "Select",
            options: [],
            bind: {
              style: {
                width: "100px"
              }
            },
            // clearable: false,
            placeholder() {
              return this.$t("keyword") + this.$t("type");
            },
            methods: {
              async list({field, searchForm}) {
                let res = (await getSelectType("OMS_B2B_KEYWORDS")).data
                  .payload["OMS_B2B_KEYWORDS"];
                field.options = res;
                searchForm[field.key] = res[0].value;
                this.$forceUpdate();
              }
            }
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            bind: {
              type: "textarea",
              rows: 1
            },
            component: "Input",
          }
        ],
        btns: {
          list: [
            {
              name: () => this.$t("changeOrder"),
              type: "add",
              fnName: "add",
              bind: {
                type: "primary"
                // icon: "md-swap",
              }
            },
            {
              name: () => this.$t("export"),
              id: 195,
              btnBind: {
                // icon: "md-arrow-down",
                type: "primary"
              },
              list: [
                {
                  name: this.$t("ListData"),
                  type: "1",
                  fnName: "export",
                  bind: {
                    icon: "md-arrow-down",
                    type: "primary"
                  }
                },
                {
                  name: "sku" + this.$t("detail"),
                  type: "2",
                  fnName: "export",
                  bind: {
                    icon: "md-arrow-down",
                    type: "primary"
                  }
                },
                {
                  name: this.$t("relation") + this.$t("inbound"),
                  type: "3",
                  fnName: "export",
                  bind: {
                    icon: "md-arrow-down",
                    type: "primary"
                  }
                },
                {
                  name: this.$t("relation") + this.$t("doubleFeright"),
                  type: "6",
                  fnName: "export",
                  bind: {
                    icon: "md-arrow-down",
                    type: "primary"
                  }
                },
                {
                  name: this.$t("TrackAssociation"),
                  type: "9",
                  fnName: "export",
                  bind: {
                    icon: "md-arrow-down",
                    type: "primary"
                  }
                },
                {
                  name: this.$t("关联,平台,信息"),
                  type: "7",
                  fnName: "export",
                  bind: {
                    icon: "md-arrow-down",
                    type: "primary"
                  }
                }
              ]
            },
            {
              name: () =>
                this.$t("batch") + this.$t("updateFile") + this.$t("boxOrder"),
              type: "upload",
              fnName: "upload",
              id: 431,
              bind: {
                type: "primary",
                icon: "ios-cloud-upload"
              }
            },
            {
              name: () =>
                this.$t("batch") +
                this.$t("modify") +
                this.$t("boxOrder") +
                this.$t("information"),
              type: "bachUpdate",
              fnName: "bachUpdate",
              id: 467,
              bind: {
                type: "primary",
                icon: "ios-cloud-upload"
              },
              disabled() {
                return !this.selectAll.length;
              }
            },
            {
              name: () =>
                this.$t("batch") +
                this.$t("download") +
                this.$t("boxOrder") +
                this.$t("files"),
              type: "downBox",
              fnName: "downBox",
              // id: 467,
              bind: {
                type: "success",
                icon: "md-arrow-down"
              },
              disabled() {
                return !this.selectAll.length;
              }
            },

            {
              name: () => this.$t("updateFile") + this.$t("doubleFeright"),
              type: "uploadInfo",
              fnName: "uploadInfo",
              id: 435,
              bind: {
                type: "primary",
                icon: "ios-cloud-upload"
              },
              data: 1
            },
            {
              name: () =>
                this.$t("updateFile") +
                this.$t("Shuangqing") +
                this.$t("finalCost"),
              type: "uploadInfoB2B",
              fnName: "uploadInfo",
              data: 2,
              id: 1192,
              bind: {
                type: "primary",
                icon: "ios-cloud-upload"
              }
            },
            {
              name: () => this.$t("batch") + this.$t("inbound"),
              type: "uploadInbound",
              id: 549,
              fnName: "uploadInbound",
              bind: {
                type: "primary",
                icon: "ios-cloud-upload"
              }
            },
            {
              name: () =>
                this.$t("batch") +
                this.$t("confirm") +
                this.$t("invoiceWeight"),
              type: "confrimWeight",
              fnName: "confrimWeight",
              bind: {
                type: "primary"
              },
              disabled() {
                return !this.selectAll.length;
              }
            },
            {
              name: () => this.$t("batch") + this.$t("template"),
              btnBind: {
                // icon: "md-arrow-down",
                type: "primary"
              },
              list: [
                {
                  name: "NOON" + this.$t("PackingSlip") + " PL",
                  type: "1",
                  url: "/static/templates/NOONPackingList.xlsx",
                  fnName: "down",
                  size: "small",
                  bind: {
                    type: "primary"
                  }
                },
                {
                  name: "FBA" + this.$t("PackingSlip") + "PL",
                  type: "2",
                  url: "/static/templates/FBAPackingList.xlsx",
                  fnName: "down",
                  size: "small",
                  bind: {
                    type: "primary"
                  }
                },
                {
                  name: "FBT" + this.$t("PackingSlip") + "PL",
                  type: "2",
                  url: "/static/templates/FBTPackingList.xlsx",
                  fnName: "down",
                  size: "small",
                  bind: {
                    type: "primary"
                  }
                },
                {
                  name: "FBJ" + this.$t("PackingSlip") + "PL",
                  type: "2",
                  url: "/static/templates/FBJPackingList.xlsx",
                  fnName: "down",
                  size: "small",
                  bind: {
                    type: "primary"
                  }
                },
                {
                  name: this.$t("ListOverseasWarehouses"),
                  type: "3",
                  url: "/static/templates/WMSPutShelf.xlsx",
                  fnName: "down",
                  size: "small",
                  bind: {
                    type: "primary"
                  }
                },
                {
                  name: this.$t("DoorServicePackingList") + " PL",
                  type: "4",
                  url: "/static/templates/D2DPackingList.xlsx",
                  fnName: "down",
                  size: "small",
                  bind: {
                    type: "primary"
                  }
                },
                {
                  name: "材质和用途 PL",
                  type: "5",
                  url: "/static/templates/D2DPackingList.xlsx",
                  fnName: "down",
                  size: "small",
                  bind: {
                    type: "primary"
                  }
                }
              ]
            },
            {
              name: () => this.$t("batch") + this.$t("bindFreight"),
              type: "branchFeright",
              fnName: "branchFeright",
              bind: {
                type: "primary"
              },
              id: 953,
              disabled() {
                return !this.selectAll.length;
              }
            },
            {
              name: () =>
                this.$t("batch") + this.$t("export") + this.$t("bindFreight"),
              type: "exportFeright",
              fnName: "exportFeright",
              bind: {
                type: "primary"
              },
              disabled() {
                return !this.selectAll.length;
              }
            },
            {
              name: () => this.$t("batch") + this.$t("doubleFeright"),
              type: "doubleFeright",
              fnName: "doubleFeright",
              bind: {
                type: "primary"
              },
              disabled() {
                return !this.selectAll.length;
              }
            },
            {
              name: () => this.$t("addValueService"),
              type: "addValueService",
              fnName: "addValueService",
              bind: {
                type: "primary"
              },
              // id: 953,
              disabled() {
                return !this.selectAll.length;
              }
            },
            {
              name: () => this.$t("updateTrace"),
              type: "updateTrace",
              fnName: "updateTraceFun",
              bind: {
                type: "primary"
              },
              // id: 953,
              disabled() {
                return !this.selectAll.length;
              }
            },
            {
              name: () => this.$t("batch") + this.$t("company"),
              type: "service",
              fnName: "service",
              // id: 467,
              bind: {
                type: "primary"
              },
              disabled() {
                return !this.selectAll.length;
              }
            },
            {
              name: () =>
                this.$t("batch") +
                this.$t("setting") +
                this.$t("dingcangCompany"),
              type: "setAgent",
              fnName: "setAgent",
              id: 1193,
              bind: {
                type: "primary"
              },
              disabled() {
                return !this.selectAll.length;
              }
            },
            {
              name: () => this.$tz("批量,删除,分包"),
              type: "batchDel",
              fnName: "batchDel",
              bind: {
                type: "error"
              },
              id: 1933
            },
            {
              name: () =>
                this.$t("batch") + this.$t("setting") + this.$t("Remarks"),
              type: "batchSetRemarks",
              fnName: "batchSetRemarks",
              id: 1229,
              bind: {
                type: "primary"
              },
              disabled() {
                return !this.selectAll.length;
              }
            },
            {
              name: () => "B2B" + this.$t("apportion"),
              fnName: "B2BCostApportion",
              type: "B2BCostApportion",
              bind: {
                type: "primary"
              },
              id: 1251
            }
          ],
          methods: {
            batchDel() {
              this.getModal("batchDel").open(null, function () {
                this.setTitle(this.$tz("批量,删除,分包"));
              });
            },
            doubleFeright() {
              // 判断是否一个出发国家，一个目的国家，一种运输渠道
              let fromCountry = {}, toCountry = {}, transportMode = {}, list = []
              for (const element of this.selectAll) {
                fromCountry[element.from_country] = true
                toCountry[element.to_country] = true
                transportMode[element.transport_code] = true
                list.push({airway_number: element.airway_number})
              }
              if (Object.keys(fromCountry).length > 1) {
                this.$Message.error('所选的出发国家不能为不同的出发国家')
                return
              }
              if (Object.keys(toCountry).length > 1) {
                this.$Message.error('所选的目的国家不能为不同的国家')
                return
              }
              if (Object.keys(transportMode).length > 1) {
                this.$Message.error('所选的运输方式存在多个')
                return
              }

              // 压入到Store准备调用
              this.$store.commit('updateCateVars', {
                fromCountry: Object.keys(fromCountry)[0],
                toCountry: Object.keys(toCountry)[0],
                transportMode: Object.keys(transportMode)[0],
              })

              this.getModal("doubleFeright").open({}, function () {
                this.list = list;

                this.setTitle(this.$t("doubleFeright"));
              });
            },
            B2BCostApportion() {
              this.getModal("B2BCostApportion").open({}, function () {
                this.setTitle("B2B" + this.$t("apportion"));
              });
            },
            batchSetRemarks() {
              let ids = this.selectAll.map(t => t.id);
              this.getModal("batchSetRemarks").open({ids}, function () {
                this.setTitle(
                  this.$t("batch") + this.$t("setting") + this.$t("Remarks")
                );
              });
            },
            setAgent() {
              this.getModal("setAgent").open();
            },
            service() {
              this.getModal("showService").open(
                {
                  ids: this.selectAll.map(item => item.id)
                },
                function () {
                  this.setTitle(this.$t("batch") + this.$t("company"));
                }
              );
            },
            updateTraceFun() {
              this.getModal("updateTrace").open(
                {
                  airway_number: this.selectAll.map(item => item.airway_number)
                },
                function () {
                }
              );
            },
            exportFeright() {
              let data = {
                airway_number: this.selectAll.map(item => item.airway_number)
              };
              this.handleRequestMethods("exportFinance", data, true, true).then(
                res => {
                  window.open(this.$globalUrl + res.payload.src);
                }
              );
            },
            branchFeright() {
              let data = {
                airway_number: this.selectAll.map(item => item.airway_number)
              };
              this.getModal("branchFeright").open(data, function () {
                this.setTitle(this.$t("batch") + this.$t("bindFreight"));
              });
            },
            downBox(row) {
              let data = {
                airway_number: this.selectAll.map(item => item.airway_number)
              };
              this.handleRequestMethods("downloadBox", data, true, true).then(
                res => {
                  window.open(this.$globalUrl + res.payload.src);
                }
              );
            },
            confrimWeight() {
              let data = {
                airway_number: this.selectAll.map(item => item.airway_number)
              };
              this.$Modal.confirm({
                title: this.$t("batch") + this.$t("confirmWeight"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods("checkWeight", data).then(res => {
                    this.$Message["success"]({
                      background: true,
                      content: res.msg
                    });
                    this.getList();
                  });
                }
              });
            },
            export({field, searchForm}) {
              this.openLoading();
              exportSelection({
                export_type: field.type,
                export_id: this.selectAll.map(item => item.id),
                ...searchForm
              }).then(res => {
                this.$Message["success"]({
                  background: true,
                  content: res.data.msg
                });
                window.open(this.$globalUrl + res.data.payload.src);
                this.closeLoading();
              });
            },
            upload() {
              this.getModal("upload").open(null, () => {
                this.getModal("upload").setTitle(this.$t("updateFile"));
                this.getModal("upload").disabledConfirm = true;
              });
            },
            bachUpdate() {
              this.getModal("showBachPack").open(null, function () {
                this.setTitle(
                  this.$t("batch") + this.$t("updateFile") + this.$t("boxOrder")
                );
              });
            },
            uploadInfo({field}) {
              let data = {
                url: "https://oms.vnlin.com/doc/zh-CN/B2BExtend.xlsx",
                requestApi: uploadInfoFiles,
                resTable: false
              };
              if (field.data == 2) {
                data.url = "/doc/zh-CN/成本费用录入模板.xlsx";
                data.requestApi = uploadB2BFiles;
              }
              this.getModal("showUpload").open(data);
            },
            uploadInbound() {
              let data = {
                url: "https://oms.vnlin.com/static/templates/inbound.xlsx",
                requestApi: uploadInboundFile,
                resTable: true
              };
              this.getModal("showUpload").open(data);
            },
            add() {
              this.getModal("add").open(null, () => {
                this.getModal("add").type = "add";
              });
            },
            down({field}) {
              // window.open(this.$globalUrl + field.url);
              window.open(
                this.$globalUrl +
                field.url
                  .replace("static", "doc")
                  .replace("templates", this.$i18n.locale)
              );
            },
            addValueService({field}) {
              this.getModal("ortherCost").open({
                airway_number: this.selectAll.map(item => item.airway_number)
              });
            }
          }
        }
      },
      fields: [
        {
          type: "checkbox",
          width: 60,
          fixed: "left"
        },
        {
          name: () => this.$t("order_number"),
          copy: true,
          key: "airway_number",
          fixed: "left",
          component: "Button",
          bind: {
            type: "primary",
            size: "small"
          },
          header: {
            copy: true
          },
          methods: {
            click({row}) {
              this.$page.getModal("showDetails").open({row}, function () {
                this.setTitle(row.airway_number);
              });
            }
          },
          width: 160
        },

        {
          name: () => this.$t("salesman"),
          key: "staffAccount",
          align: "left",
          minWidth: 110
        },
        {
          name: () => this.$t("serviceAccount"),
          key: "clientServiceAccount",
          align: "left",
          minWidth: 110
        },
        {
          name: () => this.$tz("分公司,客服"),
          key: "branch_customer_service",
          minWidth: 110
        },
        {
          name: () => this.$tz("双清,客服"),
          key: "dbl_customer_service",
          minWidth: 110
        },
        {
          name: () => this.$t("clientName"),
          key: "customerAccount",
          align: "left",
          minWidth: 110
        },
        {
          name: () => this.$t("是否支付"),
          key: "paymentText",
          align: "center",
          minWidth: 110,
          component: ({row}) => {
            return row.payment ? "Button" : 'span';
          },
          bind: {
            type({row}) {
              return row.payment ? (row.shouldPayment ? 'warning' : 'primary') : 'default'
            },
            size: "small"
          },
          methods: {
            click: ({row}) => {
              if (row.payment) {
                // 需要支付的情况
                if (row.shouldPayment) {
                  // 尚未支付
                  if (confirm('是否标记为已经支付?')) {
                    let remarks = prompt('请输入支付的备注信息')
                    if (!remarks) {
                      alert('没有备注信息无法提交信息')
                    } else {
                      markAsPaid({shipmentNumber: row.airway_number, remarks}).then(res => {
                        alert(res.data.msg)
                        this.$refs['table'].getList()
                      })
                    }
                  }
                }  else {
                  // 不需要支付
                  alert(row.paymentRecord)
                }
              }
            }
          }

        },
        {
          name: () => this.$t("invoicePCS"),
          key: "quantity",
          minWidth: 110,
          component: ({row}) => {
            return row.data_type == 2 ? "Button" : "span";
          },
          bind: {
            type: "primary",
            size: "small"
          },
          methods: {
            click({row}) {
              row.data_type == 2 &&
              this.$page
                .handleRequestMethods(
                  "fordel",
                  {airway_number: row.airway_number},
                  false,
                  true
                )
                .then(res => {
                  this.$page.getModal("quantity").open({row}, function () {
                    this.setTitle(row.airway_number);
                    this.list = res.payload;
                  });
                });
            }
          }
        },

        {
          name: () => this.$t("is_solely"),
          key: "is_solely",
          width: 80
        },
        {
          name: () => this.$t("assistDepartment"),
          key: "department",
          minWidth: 110
        },
        {
          name: () => this.$t("shipper_company_cn"),
          key: "shipper_company_cn",
          align: "left",
          minWidth: 110
        },
        {
          name: () => this.$t("company"),
          key: "consignee",
          align: "left",
          minWidth: 80
        },
        {
          name: () => this.$tz("平台"),
          key: "platform",
          minWidth: 110
        },
        {
          name: () => this.$t("order_t") + this.$t("tip"),
          key: "track_status",
          minWidth: 110
        },
        {
          name: () => this.$t("tracker_code"),
          key: "status",
          minWidth: 80,
          component: "Button",
          bind: {
            type: "primary",
            size: "small"
          },
          methods: {
            click({row}) {
              this.$page.getModal("showStatus").open({row}, function () {
                this.setTitle(
                  row.airway_number + "(" + this.$t("trajectory") + ")"
                );
              });
            }
          }
        },
        {
          name: () => this.$t("tracker_description"),
          key: "status_remarks",
          minWidth: 110
        },
        // {
        //   name: () => this.$t("tracker_description_cn"),
        //   key: "status_cn",
        //   align: "left",
        //   minWidth: 110
        // },
        {
          name: () => this.$t("status_time"),
          key: "status_time",
          minWidth: 110
        },
        {
          name: () => this.$t("ConfirmedWeight"),
          key: "isConfirmed",
          minWidth: 110
        },
        {
          name: () => this.$t("B2BECommerce"),
          key: "isUnpack",
          minWidth: 110
        },
        {
          name: () => this.$t("UnpackedFinished"),
          key: "isUnpackFinish",
          minWidth: 110
          // methods: {
          //   render({ value }) {
          //     return value ? this.$t("YES") : this.$t("NO");
          //   }
          // }
        },

        {
          name: () => this.$t("from_country"),
          key: "from_country_title",
          align: "left",
          minWidth: 80
        },
        {
          name: () => this.$t("target_country"),
          key: "target_country_title",
          align: "left",
          minWidth: 80
        },
        {
          name: () => this.$t("city_name"),
          key: "city_name",
          width: 80
        },
        {
          name: () => this.$t("warehouseName"),
          key: "warehouse",
          align: "left",
          minWidth: 80
        },
        {
          name: () => this.$t("dingcangCompany"),
          key: "dingcang_company",
          align: "left",
          minWidth: 80
        },
        {
          name: () => this.$t("method_name"),
          key: "transport_name",
          minWidth: 110,
          component({row}) {
            return this.hasPermission(1586) && !row.outboundStatus
              ? "Button"
              : "span";
          },
          bind: {
            type: "primary",
            size: "small"
          },
          methods: {
            click({row}) {
              if (this.hasPermission(1586) && !row.outboundStatus) {
                this.$page.getModal("updateTransport").open(row, function () {
                  this.setTitle(
                    row.airway_number +
                    "(" +
                    this.$t("Revise Transport Mode") +
                    ")"
                  );
                });
              }
            }
          }
        },
        {
          name: () => this.$tz("分包,汇总,重量"),
          key: "unpack_check_weight",
          minWidth: 110
        },
        {
          name: () => this.$tz("拆包,数量"),
          key: "unpack_number",
          minWidth: 110
        },
        {
          name: () => this.$t("charge_params") + "(KG)",
          key: "charging_weight",
          minWidth: 120
        },

        {
          name: () => this.$t("charging_volume") + "(CBM)",
          key: "charging_volume",
          minWidth: 120
        },
        {
          name: () => this.$t("coll"),
          children: [
            {
              name: () => this.$t("currencyCode"),
              key: "cod_currency",
              minWidth: 120
            },
            {
              name: () => this.$t("reChAmount"),
              key: "cod_amount",
              minWidth: 120
            },
            {
              name: () => this.$t("HandlingFee"),
              key: "cod_handlefee",
              minWidth: 120
            }
          ]
        },
        {
          name: () => this.$t("ValueAddedServiceFees"),
          key: "service_fee",
          width: 120,
          component: ({row}) => (row.service_fee ? "Button" : "span"),
          bind: {
            type: "primary",
            size: "small"
          },
          methods: {
            click({row}) {
              if (row.service_fee) {
                this.$page
                  .handleRequestMethods(
                    "getServiceDetail",
                    row.airway_number,
                    false,
                    true
                  )
                  .then(res => {
                    this.$page
                      .getModal("ortherCostList")
                      .open(null, function () {
                        this.setTitle(
                          this.$t("valueService") + ":" + row.airway_number
                        );
                        this.list = res.payload;
                      });
                  });
              }
            }
          }
        },
        {
          name: () => this.$t("createTime"),
          key: "create_time",
          minWidth: 170
        },
        {
          name: () => this.$t("inboundTime"),
          key: "inbound_time",
          minWidth: 170
        },
        {
          name: () => this.$t("InboundWarehouse"),
          key: "inbound_warehouse",
          minWidth: 110
        },
        {
          name: () => this.$t("outboundTime"),
          key: "outbound_time",
          minWidth: 170
        },
        {
          name: () => this.$t("dept_HK") + this.$t("time"),
          key: "depart_port_time",
          minWidth: 170
        },
        {
          name: () => this.$t("arrival_HK") + this.$t("time"),
          key: "landed_time",
          minWidth: 170
        },
        {
          name: () => this.$t("clearance_date"),
          key: "clearance_time",
          minWidth: 170
        },
        {
          name: () => this.$t("pod") + this.$t("time"),
          key: "signed_time",
          minWidth: 170
        },
        // {
        //   name: () => this.$t("cod_status"),
        //   key: "dbl_status_txt",
        //   minWidth: 100
        // },

        // {
        //   name: () => this.$t("order_address"),
        //   key: "consignee_address",
        //   minWidth: 150
        // },
        // {
        //   name: () => this.$t("order_phone"),
        //   key: "consignee_cellular",
        //   minWidth: 140
        // },
        {
          name: () => this.$t("service") + this.$t("Remarks"),
          key: "cs_remarks",
          minWidth: 180
        },
        {
          name: () => this.$tz("其他,备注"),
          key: "goods_remarks",
          minWidth: 180
        },
        // {
        //   name: () => this.$t("order_userRef"),
        //   key: "client_refer_code",
        //   minWidth: 110
        // },
        // {
        //   name: () => this.$t("print") + this.$t("time"),
        //   key: "print_time",
        //   minWidth: 130
        // },
        {
          type: "btns",
          width: 620,
          name: () => this.$t("operation"),
          fixed: "right",
          headerAlign: "center",
          align: "left",
          btnBind: {
            type: "primary",
            size: "small",
            transfer: true
          },
          list: [
            {
              name: () => this.$t("trajectory"),
              type: "showStatus",
              fnName: "showStatus"
              // bind: {
              //   type: "success"
              // }
            },

            {
              name: () => this.$t("unpack"),
              type: "unpack",
              fnName: "unpack",
              id: 548,
              bind: {
                type: "warning"
              }
            },
            {
              name: () => this.$t("inbound"),
              type: "inbound",
              fnName: "inbound",
              id: 327,
              bind: {
                type: "info"
              },
              afterIcon({row}) {
                return row.inboundStatus ? "md-checkbox" : "ios-square";
              }
            },
            {
              name: () => this.$t("out"),
              type: "outbound",
              fnName: "outbound",
              id: 434,
              bind: {
                type: "warning"
              },
              afterIcon({row}) {
                return row.abnormalStatus
                  ? "md-close-circle"
                  : row.outboundStatus
                    ? "md-checkbox"
                    : "ios-square";
              }
            },
            {
              name: () => this.$t("doubleFeright"),
              type: "info",
              fnName: "info",
              // id: 196,
              bind: {
                type: "success"
              },
              afterIcon({row}) {
                return row.abnormalStatus
                  ? "md-close-circle"
                  : row.confirmed_time > 0
                    ? "md-checkbox"
                    : "ios-square";
              }
            },
            {
              name: () => this.$t("bindFreight"),
              type: "freight",
              fnName: "freight",
              id: 197,
              bind: {
                type: "error"
              },
              target_type: 1,
              afterIcon({row}) {
                return row.abnormalStatus
                  ? "md-close-circle"
                  : row.finance_time > 0
                    ? "md-checkbox"
                    : "ios-square";
              }
            },
            {
              name: () => this.$t("账单"),
              type: "billStatus",
              fnName: "openBillPage",
              bind: {
                type: "error"
              },
              afterIcon({row}) {
                return row.billStatus ? "md-checkbox" : "ios-square";
              }
            },
            {
              name: () => this.$t("branchOffice") + this.$t("bindFreight"),
              type: "branchfreight",
              fnName: "freight",
              id: 197,
              bind: {
                type: "error"
              },
              show({row}) {
                return true;
              },
              target_type: 2,
              afterIcon({row}) {
                return row.branch_finance_time > 0
                  ? "md-checkbox"
                  : "ios-square";
              }
            },
            {
              name: () => this.$t("finalCost"),
              type: "openCost",
              fnName: "openCost",
              bind: {
                type: ({row}) => {
                  return row.costType !== "NO" ? "warning" : "default";
                }
              },
              id: 1147
            },
            {
              name: () => this.$t("sheet"),
              type: "sheet",
              id: 194,
              // fnName: "sheet",
              btnBind: {
                type: "primary",
                size: "small"
              },
              list: [
                {
                  name: () => '10*10' + this.$t("size"),
                  type: "mini",
                  fnName: "sheet"
                },
                {
                  name: () => '10*15' + this.$t("size"),
                  type: "standard",
                  fnName: "sheet"
                },
                {
                  name: () => this.$t("A4") + this.$t("size"),
                  type: "a4",
                  fnName: "sheet"
                }
              ]
            },
            {
              name: () => this.$t("Revise  CTNS"),
              type: "update",
              fnName: "update",
              bind: {
                type: "primary"
              }
            },
            {
              name: () => '修改信息',
              type: "modify",
              fnName: "modify",
              bind: {
                type: "primary"
              }
            },
            // {
            //   name: () => this.$t("Revise Transport Mode"),
            //   type: "updateTransport",
            //   fnName: "updateTransport",
            //   bind: {
            //     type: "primary",
            //   },
            //   id: 1586,
            //   disabled: ({ row }) => row.outboundStatus,
            // },
            {
              name: () => this.$t("boxOrder"),
              type: "packList",
              fnName: "packList",
              id: 430,
              bind: {
                type: ({row}) => {
                  return row.hasBox
                    ? row.hasBox === 2
                      ? "success"
                      : "error"
                    : "default";
                }
              }
            },
            {
              name: () => this.$t("operationLog"),
              type: "operationLog",
              fnName: "operationLog",
              bind: {
                type: "primary"
              },
              id: 1516
            },
            {
              name: () => this.$tz("调账,证明"),
              type: "adjust",
              fnName: "adjust",
              id: 1906,
              apiData: {
                airway_number: this.awbno
              },
              bind: {
                type: "primary"
              }
            },
            {
              name: () => this.$tz("派送单"),
              type: "print",
              btnBind: {
                type: "primary",
                size: "small"
              },
              list: [
                {
                  name: () => "PDF",
                  type: "print",
                  fnName: "print"
                },
                // {
                //   name: () => "Excel",
                //   type: "excel",
                //   fnName: "print"
                // }
              ]
            },
            {
              name: () => this.$t("异常"),
              type: "abnormal",
              fnName: "abnormal",
              // id: 197,
              bind: {
                type: "error"
              },
              id: 1908,
              target_type: 1,
              afterIcon({row}) {
                return row.abnormalStatus ? "md-checkbox" : "ios-square";
              }
            },
            {
              name: () => this.$t("delete"),
              type: "delete",
              fnName: "delete",
              id: 556
            }
          ],
          methods: {
            openBillPage({row}) {
              this.toPage('b2b_bill_hq', {
                keywordsType: 2,
                keywords: row.airway_number,
              })
            },
            adjust({row}) {
              this.getModal("adjust").open(row, function () {
                this.setTitle(this.$tz("调账,证明"));
              });
            },
            abnormal({row}) {
              this.handleRequestMethods(
                "abnormalInfo",
                {airway_number: row.airway_number},
                false,
                true
              ).then(res => {
                res.payload.airway_number = row.airway_number;
                this.getModal("abnormal").open(res.payload, function () {
                  this.setTitle(
                    row.airway_number + "(" + this.$t("abnormal") + ")"
                  );
                });
              });
            },
            print: ({row, field}) => {
              if (field.type === "excel") {
                this.$refs["table"]
                  .handleRequestMethods(
                    "exportDeliverty",
                    {
                      airway_number: row.airway_number,
                      quantity: row.quantity,
                      cod_currency: row.cod_currency,
                      cod_amount: row.cod_amount,
                      consignee_contact: row.consignee_contact,
                      consignee_cellular: row.consignee_cellular,
                      consignee_address: row.consignee_address
                    },
                    true,
                    true
                  )
                  .then(res => {
                    window.open(this.$globalUrl + res.payload.src);
                  });
              } else this.print(row);
            },
            operationLog({row}) {
              this.handleRequestMethods(
                "log",
                {airwayNumber: row.airway_number},
                false,
                true
              ).then(res => {
                this.getModal("log").open({}, function () {
                  this.list = res.payload;
                  this.setTitle(
                    row.airway_number + "(" + this.$t("operationLog") + ")"
                  );
                });
              });
            },
            openCost({row}) {
              row.resType = 1;
              this.getModal("openCost").open(row, function () {
                this.setTitle(this.$t("finalCost"));
              });
            },
            showStatus({row}) {
              this.getModal("showStatus").open({row}, function () {
                this.setTitle(
                  row.airway_number + "(" + this.$t("trajectory") + ")"
                );
              });
            },
            unpack({row}) {
              this.getModal("showUnpack").open({row}, function () {
                this.setTitle(
                  row.airway_number + "(" + this.$t("unpack") + ")"
                );
              });
            },
            modify({row}) {
              this.$store.commit('setModifyShipmentParams', row)
              this.getModal("modify").open({row}, function () {
                this.setTitle(
                  row.airway_number + "(修改信息)"
                );
              });
            },
            info({row}) {
              this.getModal("showInfo").open({row}, function () {
                this.setTitle(
                  row.airway_number + "(" + this.$t("doubleFeright") + ")"
                );
              });
            },
            freight({row, field}) {
              this.getModal("showFreight").open(
                {
                  row: Object.assign({}, row, {
                    target_type: field.target_type
                  })
                },
                function () {
                  this.setTitle(
                    row.airway_number + "(" + this.$t("bindFreight") + ")"
                  );
                }
              );
            },
            sheet({row, field}) {
              printDouble({id: row.airway_number, type: field.type}).then(
                res => {
                  if (res.data.status) {
                    window.open(
                      this.$globalUrl + res.data.data[0].url,
                      "_blank"
                    );
                  } else {
                    this.$Message["error"]({
                      background: true,
                      content: res.data.msg
                    });
                  }
                }
              );
            },
            inbound({row}) {
              this.getModal("showInbound").open({row}, function () {
                this.setTitle(
                  row.airway_number + "(" + this.$t("inbound") + ")"
                );
              });
            },
            outbound({row}) {
              this.getModal("showOutbound").open({row}, function () {
                this.setTitle(
                  row.airway_number + "(" + this.$t("outbound") + ")"
                );
              });
            },
            updateTransport({row}) {
              this.getModal("updateTransport").open(row, function () {
                this.setTitle(
                  row.airway_number +
                  "(" +
                  this.$t("Revise Transport Mode") +
                  ")"
                );
              });
            },
            update({row}) {
              this.getModal("update").open({row}, function () {
                this.setTitle(
                  row.airway_number +
                  "(" +
                  this.$t("modify") +
                  this.$t("invoicePCS") +
                  ")"
                );
                this.$page
                  .handleRequestMethods(
                    "getGoodsInfo",
                    row.airway_number,
                    false,
                    true
                  )
                  .then(res => {
                    this.list = res.payload;
                  });
              });
            },
            async packList({row}) {
              let res = await this.handleRequestMethods("getPackList", {
                id: row.airway_number
              });
              let data = res.payload.deliver ? res.payload.deliver : {};
              data["id"] = row.airway_number;
              data["file"] = null;
              data["is_solely"] =
                res.payload.deliver.is_solely === "YES"
                  ? this.$t("YES")
                  : this.$t("NO");
              data["is_verify"] = res.payload.deliver.is_verify;
              // console.log(data);
              this.getModal("showPack").open(data, function () {
                this.list = res.payload.rows;
                this.pageConfig.data["id"] = row.airway_number;
                // this.$page.openLoading();
                // console.log("打开箱单", this);
                // this.pageConfig.loading = true;
                // this.$page
                //   .handleRequestMethods("getPackList", row.airway_number)
                //   .then(res => {
                //     this.list = res.payload.list;
                //     this.pageConfig.loading = false;
                //   });
                this.setTitle(
                  row.airway_number + "(" + this.$t("boxOrder") + ")"
                );
              });
            },
            delete({row}) {
              this.$Modal.confirm({
                title: this.$t("delete"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods("del", row.airway_number).then(
                    res => {
                      this.$Message["success"]({
                        background: true,
                        content: res.msg
                      });
                      this.getList();
                    }
                  );
                }
              });
            }
          }
        }
      ]
    };
  }
}
;
</script>
<style>
.header-title {
  display: flex;
  height: 40px;
  align-items: center;
}
</style>
